export default {
  translation: {
    // Added Showroom Replacements
    'showroom_unit_not_found': 'Showroom unit not found',
    'failed_load_showroom': 'Failed to load showroom details',
    'failed_delete_showroom': 'Failed to delete showroom',
    'failed_update_status': 'Failed to update showroom status',
    'loading_showroom_data': 'Loading showroom data…',
    'back_to_showrooms': 'Back to Showrooms',
    'showroom_not_found_title': 'Showroom Not Found',
    'showroom_specifications': 'Showroom Specifications',
    'confirm_delete_showroom_p1': 'Are you sure you want to permanently delete showroom ',
    'confirm_delete_showroom_p2': '? This action cannot be undone.',
    'configure_showroom_park': 'Configure Showroom Park',
    'register_new_showroom_park': 'Register New Showroom Park',
    'total_showrooms_label': 'Total Showrooms',
    'total_showrooms_desc': 'Total number of individual showroom units in the complex.',
    'invalid_bulk_showroom_data': 'Invalid data format for bulk showroom creation',
    'failed_create_bulk_showrooms': 'Failed to create bulk showrooms',
    'init_showrooms': 'Init Showrooms',
    'no_showrooms_in_complex': 'No showroom units found in this complex yet.',
    'add_first_showroom': 'Add First Showroom',
    'add_showroom_btn': 'Add Showroom',
    'no_showrooms_found_title': 'No Showrooms Found',
    'failed_load_showroom_data': 'Failed to load showroom data',
    'update_showroom_desc': 'Update this showroom unit\'s specifications.',
    'register_showroom_desc': 'Register a new showroom unit in this complex.',
    'identity_and_location': 'Identity & Location',
    'complex_park_name': 'Complex / Park Name',
    'physical_address': 'Physical Address',
    'enter_full_geographic_address': 'Enter the full geographic address',
    'used_for_mapping': 'Used for mapping and generating official reports.',
    'capacity_and_zoning': 'Capacity & Zoning',
    'total_blocks_zones': 'Total Blocks / Zones',
    'how_many_blocks': 'How many distinct blocks or rows does this park have?',
    'e_g_4': 'e.g. 4',
    'e_g_100': 'e.g. 100',
    'e_g_northside': 'e.g. Northside Logistics Hub',
    'update_park': 'Update Park',
    'save_complex': 'Save Complex',
    'location_and_identity': 'Location & Identity',
    'specifications': 'Specifications',
    'available_count': '{{count}} available',
    'search_by_unit': 'Search by unit #, zone, type…',
    'all_types': 'All Types',
    'no_showrooms_match': 'No showrooms match your search.',
    'clear_filters': 'Clear filters',
    'showroom_parks': 'Showroom Parks',
    'add_complex': 'Add Complex',
    'bulk_add_showrooms': 'Bulk Add Showrooms',
    'avg_utilization': 'AVG. UTILIZATION',
    'rented_sold_stat': 'RENTED / SOLD',
    'total_showrooms_stat': 'TOTAL SHOWROOMS',
    'total_complexes': 'TOTAL COMPLEXES',
    'showroom_units': 'Showroom Units',


    // App
    'apartment_system': 'Showroom Management System',
    'apartment_management': 'Showroom Management',
    'building_management': 'Complex Management',

    // Navigation - updated
    'dashboard': 'Dashboard',
    'user_management': 'User Management',
    'building_management': 'Complex Management',
    'apartment_management': 'Showroom Management',
    'owner_management': 'Owner Management',
    'tenants_management': 'Renter Management',
    'manage_tenants_and_leases': 'Manage Renters and Contracts',
    'payment_management': 'Payment Management',
    'service_management': 'Service Management',
    'report_management': 'Reports & Analytics',
    'log_management': 'Activity Logs',

    // Buildings
    'buildings': 'Complexes',
    'building_list': 'Complex List',
    'add_building': 'Add Complex',
    'edit_building': 'Edit Complex',
    'building_details': 'Complex Details',
    'building_name': 'Complex Name',
    'building_address': 'Address',
    'total_floors': 'Total Levels',
    'total_apartments': 'Total Showroom Units',

    // Apartments (renamed from Properties)
    'apartments': 'Showroom Units',
    'apartment_list': 'Showroom Unit List',
    'add_apartment': 'Add Showroom Unit',
    'add_your_first_apartment': 'Add your first showroom unit',
    'edit_apartment': 'Edit Showroom Unit',
    'apartment_details': 'Showroom Unit Details',
    'apartment_number': 'Unit Number',
    'apartment_display': 'Room {{number}}',
    'apt': 'Apt',
    'floor_number': 'Level Number',
    'floor_display': 'Zone {{number}}',
    'zone_display': 'Zone {{number}}',
    'row_display': 'Row {{number}}',
    'monthly_rent': 'Monthly Rent',
    'apartment_status': 'Status',
    'vacant': 'Vacant',
    'occupied': 'Occupied',
    'under_maintenance': 'Under Maintenance',

    // Services
    'services': 'Services',
    'service_payments': 'Service Payments',
    'generate_services': 'Generate Service Payments',
    'service_statistics': 'Service Statistics',
    'service_type': 'Service Type',
    'service_amount': 'Amount',
    'service_date': 'Service Date',
    'service_status': 'Payment Status',
    'service_paid': 'Paid',
    'service_unpaid': 'Unpaid',

    // Showroom Registry specific
    'showroom_registry': 'Showroom Registry',
    'manage_showroom_units': 'Manage and track {{count}} showroom units across all complexes.',
    'add_first_showroom_to_start': 'Add your first showroom to get started.',
    'complex_park': 'Complex / Park',
    'all_locations': 'All Locations',
    'class_type': 'Class Type',
    'all_classes': 'All Classes',
    'utilities_active': 'Utilities Active',
    'all_systems': 'All Systems',
    'yes_powered': 'Yes (Powered/Climate)',
    'none': 'None',
    'registry_error': 'Registry Error',
    'retry_connection': 'Retry Connection',
    'empty_registry': 'Empty Registry',
    'no_showrooms_logged': 'There are no showrooms logged in the system yet.',
    'initialize_first_unit': 'Initialize First Unit',
    'no_matches_found': 'No Matches Found',
    'adjust_parameters_to_locate': 'Adjust parameters to locate inventory slots.',
    'clear_parameters': 'Clear Parameters',
    'unknown_complex': 'Unknown Complex',
    'n_a': 'N/A',
    'toggle_status': 'Toggle Status',
    'manage': 'Manage',
    'x_apartments_count': '{{count}} Showroom Units',
    'x_apartment_single': '1 Showroom Unit',
    'last_updated_today': '🗓 Last updated: Today',
    'confirm_deletion_title': 'Confirm Deletion',
    'confirm_deletion_desc': 'Are you sure you want to permanently delete showroom "{{device}}"? This action cannot be undone.',

    'auth_failed_login_again': 'Authentication failed. Please log in again.',
    'access_denied_admin_role': 'Access denied. Admin role required.',
    'server_error_backend_connection': 'Server error. Please check backend connection.',
    'cannot_connect_to_server': 'Cannot connect to server. Please check your network.',
    'failed_to_load_showroom_data': 'Failed to load showroom data',

    // Reports - updated
    'revenue_report': 'Revenue Report',
    'payment_logs': 'Payment Logs',
    'occupancy_report': 'Occupancy Report',
    'monthly_payments_report': 'Monthly Payments Report',
    'monthly_payments_subtitle': 'Consolidated view of renter rent and service payments',
    'all_paid': 'All paid',
    'try_adjusting_filters': 'Try adjusting the month, year, or filters',
    'pending': 'pending',
    'total': 'Total',
    'print_receipt': 'Print Receipt',
    'monthly_revenue': 'Monthly Revenue',
    'building_revenue': 'Complex Revenue',
    'owner_revenue': 'Owner Revenue',
    'paid_until': 'Paid Until',
    'tenant_payments': 'Renter Payment Status',
    'next_billing_date': 'Next Billing Date',
    'next_payment': 'Next Payment',
    'installment_schedule': 'Installment Schedule',
    'current_tenant': 'Current Renter',
    'future_tenant_upcoming': 'Future Renter',

    // Logs
    'activity_logs': 'Activity Logs',
    'tenant_logs': 'Renter History',
    'revenue_by_user': 'Revenue By User',


    // Common
    'loading': 'Loading...',
    'save': 'Save',
    'cancel': 'Cancel',
    'edit': 'Edit',
    'delete': 'Delete',
    'add': 'Add',
    'view': 'View',
    'search': 'Search',
    'filter': 'Filter',
    'actions': 'Actions',
    'status': 'Status',
    'active': 'Active',
    'inactive': 'Inactive',
    'yes': 'Yes',
    'no': 'No',
    'confirm': 'Confirm',
    'success': 'Success',
    'error': 'Error',
    'warning': 'Warning',
    'info': 'Information',

    // App
    'apartment_system': 'Showroom System',
    'apartment_management': 'Showroom Management',

    // Authentication
    'login': 'Login',
    'logout': 'Logout',
    'login_to_continue': 'Sign in to continue',
    'dont_have_account': "Don't have an account?",
    'register': 'Register',
    'username': 'Username',
    'password': 'Password',
    'email': 'Email',
    'remember_me': 'Remember Me',
    'forgot_password': 'Forgot Password?',
    'login_failed': 'Login failed',
    'invalid_credentials': 'Invalid credentials',

    // Navigation
    'dashboard': 'Dashboard',
    'core': 'Core',
    'user_management': 'User Management',
    'property_management': 'Property Management',
    'financial_management': 'Financial Management',
    'reports_analytics': 'Reports & Analytics',
    'system': 'System',

    // Users
    'system_users': 'System Users',
    'user_list': 'User List',
    'add_user': 'Add User',
    'edit_user': 'Edit User',
    'user_profile': 'User Profile',
    'first_name': 'First Name',
    'last_name': 'Last Name',
    'phone_number': 'Phone Number',
    'role': 'Role',
    'administrator': 'Administrator',
    'front_desk': 'Front Desk',
    'accountant': 'Accountant',
    'sales_role': 'Sales',
    'created_at': 'Created At',
    'last_login': 'Last Login',
    'never': 'Never',

    // Properties
    'properties': 'Properties',
    'property_list': 'Property List',
    'add_property': 'Add Property',
    'property_owners': 'Property Owners',
    'owner_list': 'Owner List',
    'add_owner': 'Add Owner',
    'owners': 'Owners',

    // Tenants
    'tenants': 'Renters',
    'tenant_list': 'Renter List',
    'add_tenant': 'Add Renter',
    'owner_living': 'Owner Living',
    'future_tenant': 'Future Renter',

    // Payments
    'payments': 'Payments',
    'all_payments': 'All Payments',
    'record_payment': 'Record Payment',
    'manage_services': 'Manage Services',
    'generate_payments': 'Generate Payments',
    'overdue_payments': 'Overdue Payments',
    'receipts': 'Receipts',

    // Reports
    'reports': 'Reports',
    'all_reports': 'All Reports',
    'reports_dashboard': 'Reports Dashboard',
    'financial_reports': 'Financial Reports',
    'payment_reports': 'Payment Reports',
    'property_reports': 'Property Reports',

    // Settings
    'settings': 'Settings',
    'profile_settings': 'Profile Settings',
    'system_settings': 'System Settings',
    'profile': 'Profile',
    'personal_details': 'Personal Details',
    'security_settings': 'Security Settings',
    'change_password': 'Change Password',
    'current_password': 'Current Password',
    'new_password': 'New Password',
    'confirm_new_password': 'Confirm New Password',
    'organization_settings': 'Organization Settings',
    'organization_name': 'Organization Name',
    'timezone': 'Timezone',
    'subscription_plan': 'Subscription Plan',
    'trial_period': 'Trial Period',
    'days_left': '{{days}} days left',
    'update_profile_success': 'Profile updated successfully',
    'update_password_success': 'Password changed successfully',
    'update_system_success': 'System settings updated successfully',
    'settings_subtitle': 'Manage your account and system preferences',
    'manage_your_account_and_system_preferences': 'Manage your account and system preferences',
    'standard_plan': 'Standard Plan',
    'enterprise_plan': 'Enterprise Plan',

    // Notifications
    'notifications': 'Notifications',
    'view_all_notifications': 'View All Notifications',

    // WhatsApp Settings
    'whatsapp_settings': 'WhatsApp Settings',
    'whatsapp_settings_description': 'Automated WhatsApp notifications for renters and owners',
    'send_reminders_now': 'Send Reminders Now',
    'general_settings': 'General Settings',
    'whatsapp_enable': 'Enable WhatsApp Notifications',
    'whatsapp_enable_sub': 'Turn all automated WhatsApp messages on or off',
    'default_country_code': 'Default Country Code',
    'default_messaging_language': 'Default Messaging Language',
    'default_language_help': 'Used if the renter does not have a preferred language set.',
    'tenant_rent_reminder': 'Renter Rent Reminder',
    'enable_tenant_rent_reminders': 'Enable Reminders',
    'tenant_rent_reminder_sub': 'Send reminder to renters before or after payment due date',
    'days_before_due': 'Days Before Due',
    'service_fee_reminder': 'Service Fee Reminder',
    'enable_service_fee_reminder': 'Enable Service Fee Reminder',
    'service_fee_reminder_sub': 'Notify renters about upcoming service fee payments',
    'owner_reminder': 'Owner Reminder',
    'enable_owner_reminders': 'Enable Owner Reminders',
    'owner_reminder_sub': 'Notify owners when their renters have overdue payments',
    'payment_confirmation': 'Payment Confirmation',
    'send_on_payment': 'Send on Payment',
    'payment_confirmation_sub': 'Automatically sent to renter when a payment is logged',
    'preview_reminders': 'Preview Automated Reminders',
    'failed_to_load_settings': 'Failed to load settings',
    'settings_saved': 'Settings saved successfully',
    'failed_to_save': 'Failed to save',
    'server_error': 'Server error',

    // Forms
    'personal_information': 'Personal Information',
    'account_information': 'Account Information',
    'security': 'Security',
    'enter_first_name': 'Enter first name',
    'enter_last_name': 'Enter last name',
    'enter_email': 'Enter email',
    'enter_username': 'Enter username',
    'enter_password': 'Enter password',
    'enter_phone_number': 'Enter phone number',
    'confirm_password': 'Confirm Password',
    'leave_blank_to_keep_current': 'Leave blank to keep current password',

    // Validation
    'first_name_required': 'First name is required',
    'last_name_required': 'Last name is required',
    'email_required': 'Email is required',
    'invalid_email': 'Please enter a valid email address',
    'username_required': 'Username is required',
    'username_too_short': 'Username must be at least 3 characters',
    'password_required': 'Password is required',
    'password_too_short': 'Password must be at least 6 characters',
    'passwords_do_not_match': 'Passwords do not match',
    'phone_invalid_format': 'Please enter a valid phone number',

    // Actions
    'saving': 'Saving...',
    'deleting': 'Deleting...',
    'loading_users': 'Loading users...',
    'loading_user_data': 'Loading user data...',
    'update': 'Update',
    'activate': 'Activate',
    'deactivate': 'Deactivate',
    'show_all': 'Show All',
    'hide_inactive': 'Hide Inactive',
    'all_roles': 'All Roles',
    'retry': 'Retry',

    // Messages
    'no_users_found': 'No users found',
    'user_created_successfully': 'User created successfully',
    'user_updated_successfully': 'User updated successfully',
    'user_deleted_successfully': 'User deleted successfully',
    'confirm_deletion': 'Confirm Deletion',
    'delete_user_confirmation': 'Are you sure you want to delete {{name}}? This action cannot be undone.',

    // Dashboard
    'welcome_back': 'Welcome back',
    'dashboard_subtitle': 'Here\'s what\'s happening with your properties today.',
    'total_properties': 'Total Properties',
    'active_tenants': 'Active Renters',
    'monthly_revenue': 'Monthly Revenue',
    'pending_payments': 'Pending Payments',
    'recent_activity': 'Recent Activity',
    'recent_transactions': 'Recent Transactions',
    'quick_actions': 'Quick Actions',
    'alerts_notifications': 'Alerts & Notifications',
    'showing': 'Showing',
    'of': 'of',
    'users': 'users',
    'contact': 'Contact',
    'user': 'User',
    'active_properties': 'Active Properties',
    'occupancy_rate_desc': '{{rate}}% occupancy rate',
    'vs_last_month': 'vs last month',
    'overdue_amount': '{{amount}} overdue',
    'payment_desc': '{{type}} payment - Apt {{number}}',
    'overdue_payments': 'Overdue Payments',
    'overdue_payments_msg': '{{count}} renters have pending payments totaling {{amount}}',
    'view_details': 'View Details',
    'lease_expiring_soon': 'Lease Expiring Soon',
    'lease_expiring_msg': '{{count}} lease agreements expire within 30 days',
    'review_leases': 'Review Leases',
    'trial_ending_soon': 'Trial Ending Soon',
    'trial_ending_msg': 'Your trial ends in {{days}} days. Please subscribe to avoid service interruption.',
    'upgrade_plan': 'Upgrade Plan',
    'last_7_days': 'Last 7 days',
    'last_30_days': 'Last 30 days',
    'last_3_months': 'Last 3 months',
    'last_year': 'Last year',
    'error_loading_dashboard': 'Error loading dashboard',
    'reports_dashboard': 'Reports Dashboard',
    'overview_of_financial_performance': 'Overview of financial performance and property statistics',
    'view_all_reports': 'View All Reports',
    'total_revenue': 'Total Revenue',
    'total_payments_count': '{{count}} payments',
    'total_tenants': 'Total Renters',
    'new_tenants_this_year': '{{count}} new this year',
    'total_buildings_count': '{{count}} complexes',
    'total_owners': 'Total Owners Living',
    'ended_contracts_count': '{{count}} ended contracts',
    'urgent_action': 'Urgent Action',
    'monthly_revenue_year': 'Monthly Revenue - {{year}}',
    'occupancy_rate': 'Occupancy Rate',
    'quick_reports': 'Quick Reports',
    'annual_revenue': 'Annual Revenue',
    'yearly_breakdown': 'Yearly breakdown of all revenue',
    'building_revenue': 'Complex Revenue',
    'revenue_by_building': 'Revenue breakdown by complex',
    'owner_revenue': 'Owner Revenue',
    'revenue_by_owner': 'Revenue breakdown by property owner',
    'detailed_payment_history': 'Detailed payment history and logs',
    'occupied': 'Occupied',
    'vacant': 'Vacant',
    'maintenance': 'Maintenance',
    'excellent': 'Excellent',
    'good': 'Good',
    'needs_improvement': 'Needs Improvement',
    'rent': 'Rent',
    'service': 'Service',
    'deposit': 'Deposit',
    'commission': 'Commission',
    'insurance': 'Insurance',
    'total': 'Total',
    'no_recent_payments': 'No recent payments found',
    'no_overdue_payments': 'No overdue payments found',
    'overdue': 'Overdue',
    'partial': 'Partial',
    'expired': 'Expired',
    'pending': 'Pending',
    'paid': 'Paid',
    'apt': 'Apt',
    'days_overdue': 'days overdue',
    'more_overdue_tenants': 'more overdue renters...',
    'error_fetching_occupancy': 'Error fetching occupancy data',
    'failed_load_occupancy': 'Failed to load occupancy stats',
    'error_fetching_payments': 'Error fetching recent payments',
    'failed_load_payments': 'Failed to load recent payments',
    'error_fetching_tenant_status': 'Error fetching renter payment status',
    'failed_load_tenant_status': 'Failed to load renter payment status',
    'failed_to_load_report_data': 'Failed to load report data',

    "floor_number": "Level {{number}}",
    "apartment_number": "Room {{number}}",

    // Sidebar specific translations
    'core': 'Core',
    'user_management': 'User Management',
    'property_management': 'Property Management',
    'financial_management': 'Financial Management',
    'reports_analytics': 'Reports & Analytics',
    'logs_audit': 'Logs & Audit',
    'all_activities': 'All Activities',
    'tenant_activities': 'Renter Activities',
    'system': 'System',
    'bookings': 'Bookings',
    'booking_list': 'Booking List',
    'new_booking': 'New Booking',
    'booking_calendar': 'Booking Calendar',
    'waitlist': 'Waitlist',
    'analytics': 'Analytics',

    'system_users': 'System Users',
    'user_list': 'User List',
    'add_user': 'Add User',

    'buildings': 'Complexes',
    'building_list': 'Complex List',
    'add_building': 'Add Complex',

    'apartments': 'Showroom Units',
    'apartment_list': 'Showroom Unit List',
    'add_apartment': 'Add Showroom Unit',

    'owners': 'Owners',
    'owner_list': 'Owner List',
    'add_owner': 'Add Owner',

    'tenants': 'Renters',
    'tenant_list': 'Renter List',
    'add_tenant': 'Add Renter',
    'overdue_rent': 'Overdue Rent',

    'payments': 'Payments',
    'all_payments': 'All Payments',
    'record_payment': 'Record Payment',
    'payment_stats': 'Payment Statistics',

    'service_payments': 'Service Payments',
    'manage_services': 'Manage Services',
    'generate_payments': 'Generate Payments',
    'service_statistics': 'Service Statistics',

    'reports': 'Reports',
    'reports_dashboard': 'Reports Dashboard',
    'revenue_report': 'Revenue Report',
    'payment_logs': 'Payment Logs',
    'occupancy_report': 'Occupancy Report',
    'tenant_payments': 'Renter Payments',
    'building_revenue': 'Complex Revenue',
    'owner_revenue': 'Owner Revenue',

    'activity_logs': 'Activity Logs',
    'all_activities': 'All Activities',
    'tenant_activities': 'Renter Activities',
    'monthly_revenue': 'Monthly Revenue',

    'settings': 'Settings',
    'profile_settings': 'Profile Settings',
    'system_settings': 'System Settings',

    'logout': 'Logout',


    // Apartment Detail View
    'loading_apartment_details': 'Loading showroom unit details...',
    'error_loading_apartment': 'Error Loading Showroom Unit Details',
    'try_again': 'Try Again',
    'back_to_apartments': 'Back to Showroom Units',
    'apartment_not_found': 'Showroom Unit Not Found',
    'apartment_not_found_message': 'The showroom unit you are looking for does not exist or has been removed.',

    'building_and_location': 'Complex & Location',
    'building': 'Complex',
    'floor': 'Level',
    'address': 'Address',

    'apartment_details': 'Showroom Unit Details',
    'apartment_type': 'Type',
    'size': 'Size',
    'furnished': 'Has Utilities',

    'owner_information': 'Owner Information',
    'owner_name': 'Name',
    'owner_contact': 'Contact',

    'additional_information': 'Additional Information',
    'created_at': 'Created At',
    'updated_at': 'Last Updated',

    'status_management': 'Status Management',
    'status_vacant': 'Vacant',
    'status_occupied': 'Occupied',
    'status_maintenance': 'Under Maintenance',
    'status_vacant_description': 'Available for rent or lease',
    'status_occupied_description': 'Currently rented to a renter',
    'status_maintenance_description': 'Under maintenance or renovation',
    'change_status': 'Change Status To',

    'quick_actions': 'Quick Actions',
    'create_lease': 'Create Lease',
    'view_tenant_info': 'View Renter Info',
    'mark_maintenance_complete': 'Mark Maintenance Complete',
    'view_building': 'View Complex',
    'edit_apartment': 'Edit Showroom Unit',

    'same_building_apartments': 'Same Complex',
    'view_all_apartments_in_building': 'View All Units in Complex',
    'view_vacant_apartments': 'View Vacant Units',

    // Delete confirmation
    'delete_apartment_confirmation': 'Are you sure you want to delete showroom unit "{{name}}"? This action cannot be undone.',

    // Apartment Form
    'loading_apartment_data': 'Loading showroom unit data...',
    'edit_apartment': 'Edit Showroom Unit',
    'add_new_apartment': 'Add New Showroom Unit',

    'basic_information': 'Basic Information',
    'apartment_number': 'Unit Number',
    'enter_apartment_number': 'Enter showroom unit number',
    'floor_number': 'Level Number',
    'enter_floor_number': 'Enter level number',
    'size_sqm': 'Size (m²)',
    'enter_size': 'Enter size in square meters',
    'apartment_type': 'Unit Type',
    'select_apartment_type': 'Select showroom unit type',
    'select_building': 'Select complex',
    'furnished': 'Has Utilities',

    // Validation messages
    'floor_required': 'Row/Section is required',
    'row_section': 'Row / Section',
    'enter_row_section': 'Enter row or section number',
    'apartment_number_required': 'Showroom Unit number is required',
    'size_required': 'Size is required',
    'type_required': 'Type is required',
    'building_required': 'Complex is required',
    'invalid_size': 'Size must be greater than 0',

    // Form actions
    'update': 'Update',
    'save': 'Save',
    'saving': 'Saving...',


    // Apartment List
    'apartments': 'Showroom Units',
    'search_apartments': 'Search showroom units...',
    'filter': 'Filter',
    'grid_view': 'Grid',
    'list_view': 'List',
    'add_apartment': 'Add Showroom Unit',
    'all_buildings': 'All Complexes',
    'all_types': 'All Types',
    'all_statuses': 'All Statuses',
    'all': 'All',
    'vacant_apartments': 'Vacant Showroom Units',
    'occupied_apartments': 'Occupied Showroom Units',
    'maintenance_apartments': 'Under Maintenance',
    'loading_apartments': 'Loading showroom units...',
    'error_loading_apartments': 'Error Loading Showroom Units',
    'no_apartments_found': 'No Showroom Units Found',
    'no_apartments_message': 'There are no showroom units in the system yet.',
    'create_first_apartment': 'Create First Showroom Unit',
    'showing_filtered_results': 'Showing {{showing}} of {{total}} showroom units',

    // Statuses
    'vacant': 'Vacant',
    'occupied': 'Occupied',
    'maintenance': 'Under Maintenance',

    // Apartment card
    'furnished': 'Has Utilities',

    // Delete confirmation
    'delete_apartment_confirmation': 'Are you sure you want to delete showroom unit "{{name}}"? This action cannot be undone.',
    'deleting': 'Deleting...',


    // Bulk Apartment Creator
    'bulk_apartment_creation': 'Bulk Showroom Unit Creation',
    'preview': 'Preview',
    'apartment_number_format': 'Unit Number Format',
    'format_pattern': 'Format Pattern',
    'format_pattern_help': 'Use {level} for level number and {unit} for unit number. Example: {level}{unit} = 0201',
    'preview_example': 'Preview Example',
    'floor_plans': 'Level Plans',
    'add_floor_plan': 'Add Level Plan',
    'floor_plan_number': 'Level Plan {number}',
    'floors_comma_separated': 'Levels (comma-separated)',
    'unit_types': 'Unit Types',
    'add_unit_type': 'Add Unit Type',
    'unit_type_number': 'Unit Type {number}',
    'name': 'Name',
    'quantity': 'Quantity',
    'type': 'Type',
    'area_sqm': 'Area (m²)',
    'furnished': 'Has Utilities',
    'apartment_preview_count': 'Unit Preview ({count} units)',
    'floor_unit_type': 'Level {level} • {type}',
    'close': 'Close',
    'create_apartments': 'Create Showroom Units',
    'create_apartments_count': 'Create {count} Showroom Units',
    'creating_apartments': 'Creating Showroom Units...',
    'add_at_least_one_floor_plan': 'Please add at least one level plan',
    'no_apartments_to_create': 'No showroom units to create',


    'building_name_required': 'Complex name is required',
    'building_address_required': 'Complex address is required',
    'invalid_floors': 'Total levels must be at least 1',
    'invalid_apartments': 'Total showroom units must be at least 0',
    'loading_building_data': 'Loading complex data...',
    'edit_building': 'Edit Complex',
    'add_new_building': 'Add New Complex',
    'basic_information': 'Basic Information',
    'building_name': 'Complex Name',
    'enter_building_name': 'Enter complex name',
    'total_floors': 'Total Levels',
    'number_of_floors': 'Number of levels',
    'total_apartments': 'Total Showroom Units',
    'number_of_apartments': 'Number of showroom units',
    'address': 'Address',
    'enter_complete_building_address': 'Enter complete complex address',
    'cancel': 'Cancel',
    'saving': 'Saving...',
    'update': 'Update',
    'save': 'Save',


    'buildings': 'Complexes',
    'search_buildings': 'Search complexes...',
    'bulk_add_apartments': 'Bulk Add Showroom Units',
    'bulk_add': 'Bulk Add',
    'total_buildings': 'Total Complexes',
    'avg_occupancy': 'Avg. Occupancy',
    'add_building': 'Add Complex',
    'loading_buildings': 'Loading complexes...',
    'error_loading_buildings': 'Error Loading Complexes',
    'try_again': 'Try Again',
    'no_buildings_found': 'No Complexes Found',
    'no_buildings_yet': 'No Complexes Yet',
    'no_buildings_match_search': 'No complexes match "{{search}}"',
    'no_buildings_message': 'There are no complexes in the system yet. Add your first complex to get started.',
    'create_first_building': 'Create First Complex',
    'showing_filtered_results': 'Showing {{showing}} of {{total}} complexes',
    'floors': 'Levels',
    'levels': 'Levels',
    'no_inventory_data': 'No Units Yet',
    'init_units': 'Add Units',
    'apartments': 'Showroom Units',
    'occupancy': 'Occupancy',
    'vacant': 'Vacant',
    'occupied': 'Occupied',
    'no_apartments_yet': 'No showroom units yet',
    'add_apartments': '+ Add Showroom Units',
    'confirm_deletion': 'Confirm Deletion',
    'delete_building_confirmation': 'Are you sure you want to delete complex "{{name}}"? This action cannot be undone.',
    'cancel': 'Cancel',
    'deleting': 'Deleting...',
    'delete': 'Delete',
    'create_building_first': 'Please create a complex first',
    'create': 'Create Showroom Units',
    'unnamed_building': 'Unnamed Complex',
    'no_address_provided': 'No address provided',

    'select_building_for_bulk_creation': 'Select Complex for Bulk Showroom Unit Creation',

    'loading_building_details': 'Loading complex details...',
    'error_loading_building': 'Error Loading Complex',
    'try_again': 'Try Again',
    'back_to_buildings': 'Back to Complexes',
    'building_not_found': 'Complex Not Found',
    'building_not_found_message': 'The complex you are looking for does not exist or has been removed.',
    'add_apartment': 'Add Showroom Unit',
    'edit_building': 'Edit Complex',
    'generate_reports': 'Generate Reports',
    'total_apartments': 'Total Showroom Units',
    'units': 'units',
    'across_floors': 'Across {{levels}} levels',
    'across_rows': 'Across {{rows}} rows',
    'vacant_apartments': 'Vacant',
    'available_for_rent': 'Available for rent',
    'no_vacancies': 'No vacancies',
    'occupancy_rate': 'Occupancy Rate',
    'occupied_units': 'occupied units',
    'maintenance_apartments': 'Maintenance',
    'needs_attention': 'Needs attention',
    'average_apartment_size': 'Average Size',
    'furnished_apartments': 'Has Utilities',
    'utility_status': 'Utilities Status',
    'water': 'Water',
    'electricity': 'Electricity',
    'internet': 'Internet',
    'hide_details': 'Hide Details',
    'show_details': 'Show Details',
    'search_apartments': 'Search showroom units, owners, renters...',
    'all_statuses': 'All Statuses',
    'vacant': 'Vacant',
    'occupied': 'Occupied',
    'maintenance': 'Maintenance',
    'top_floor_first': 'Top Level First',
    'top_row_first': 'Top Row First',
    'ground_floor_first': 'Ground Level First',
    'bottom_row_first': 'Bottom Row First',
    'showing_results': 'Showing {{count}} of {{total}} showroom units',
    'matching': 'matching',
    'with_status': 'with status',
    'no_apartments_found': 'No Showroom Units Found',
    'no_apartments_match_filters': 'No showroom units match your current filters.',
    'no_units_found': 'No Showroom Units Found',
    'no_units_match_filters': 'No showroom units match your current filters.',
    'no_matching_units_on_row': 'No showroom units in Row {{row}} match your current filters.',
    'has_utilities': 'Has Utilities',
    'no_utilities': 'No Utilities',
    'search_showroom_units': 'Search showroom units, owners, renters...',
    'no_matching_showrooms_in_zone': 'No matching showrooms in Zone {{blockNum}}.',
    'search_showroom_placeholder': 'Search by unit #, zone, type…',
    'no_showrooms_match_search': 'No showrooms match your search.',
    'clear_filters': 'Clear Filters',
    'floor_number': 'Level {{number}}',
    'apartments': 'showroom units',
    'owner': 'Owner',
    'status': 'Status',
    'vacant_status': 'Available',
    'maintenance_status': 'Under Maintenance',
    'furnished': 'Has Utilities',
    'unfurnished': 'No Utilities',
    'no_matching_apartments_on_floor': 'No showroom units on level {{level}} match your current filters.',
    'construction_year': 'Construction Year: {{year}}',

    'activity_logs': 'Activity Logs',
    'track_all_system_activities': 'Track all system activities and changes',
    'filter': 'Filter',
    'export_to_excel': 'Export to Excel',
    'exporting': 'Exporting...',
    'filter_logs': 'Filter Logs',
    'action_type': 'Action Type',
    'all_actions': 'All Actions',
    'entity_type': 'Entity Type',
    'all_entities': 'All Entities',
    'entries_per_page': 'Entries Per Page',
    'start_date': 'Start Date',
    'end_date': 'End Date',
    'reset': 'Reset',
    'apply_filter': 'Apply Filter',
    'previous': 'Previous',
    'next': 'Next',
    'tenant_activity_logs': 'Renter Activity Logs',
    'payment_activity_logs': 'Payment Activity Logs',
    'building_activity_logs': 'Complex Activity Logs',
    'apartment_activity_logs': 'Showroom Unit Activity Logs',
    'owner_activity_logs': 'Owner Activity Logs',
    'user_activity_logs': 'User Activity Logs',
    'system_activity_logs': 'System Activity Logs',

    'monthly_revenue_by_user': 'Monthly Revenue by User',
    'export_to_excel': 'Export to Excel',
    'exporting': 'Exporting...',
    'total_revenue': 'Total Revenue',
    'total_payments': 'Total Payments',
    'recorded_by': 'Recorded by',
    'average_payment': 'Average Payment',
    'per_transaction': 'Per transaction',
    'revenue_by_user': 'Revenue by User',
    'no_revenue_data': 'No Revenue Data',
    'no_revenue_data_message': 'No payment records found for {{month}} {{year}}. Try selecting a different month or year.',


    'loading_owner_data': 'Loading owner data...',
    'error_loading_owner': 'Error Loading Owner',
    'back_to_owners': 'Back to Owners',
    'send_reminder': 'Send Reminder',
    'edit': 'Edit',
    'overview': 'Overview',
    'properties': 'Showroom Units',
    'payments': 'Payments',
    'outstanding': 'Outstanding',
    'contact_information': 'Contact Information',
    'property_overview': 'Property Overview',
    'add_apartment': 'Add Showroom Unit',
    'no_properties': 'No Showroom Units',
    'no_properties_message': 'This owner has no showroom units yet.',
    'add_first_property': 'Add First Showroom Unit',
    'view_details': 'View Details',
    'payment_history': 'Payment History',
    'no_payments': 'No Payments',
    'no_payments_message': 'No payments have been recorded yet.',
    'outstanding_fees': 'Outstanding Fees',
    'no_outstanding_fees': 'No Outstanding Fees',
    'all_fees_paid': 'All fees are up to date.',
    'total_outstanding': 'Total Outstanding',
    'add_payment': 'Add Payment',
    'property': 'Showroom Unit',
    'select_property': 'Select Showroom Unit',
    'amount': 'Amount',
    'payment_date': 'Payment Date',
    'payment_method': 'Payment Method',
    'cash': 'Cash',
    'bank_transfer': 'Bank Transfer',
    'check': 'Check',
    'credit_card': 'Credit Card',
    'online_payment': 'Online Payment',
    'reference_number': 'Reference Number',
    'notes': 'Notes',
    'cancel': 'Cancel',

    'owner_information': 'Owner Information',
    'name': 'Name',
    'phone': 'Phone',
    'owner_lives_property': 'Owner lives on the property',
    'select_apartments': 'Select Showroom Units',
    'available_apartments': 'available showroom units',
    'no_apartments_available': 'No showroom units available. All showroom units already have owners.',
    'apartment_number': 'Unit #{{number}}',
    'floor': 'Level',
    'size': 'Size',
    'type': 'Type',
    'status': 'Status',
    'cancel': 'Cancel',
    'saving': 'Saving...',
    'update_owner': 'Update Owner',
    'create_owner': 'Create Owner',
    'edit_property_owner': 'Edit Property Owner',
    'add_property_owner': 'Add Property Owner',

    'property_owners': 'Property Owners',
    'add_owner': 'Add Owner',
    'search_owners': 'Search owners...',
    'filter': 'Filter',
    'list_view': 'List',
    'grid_view': 'Grid',
    'export': 'Export',
    'exporting': 'Exporting...',
    'living_status': 'Living Status',
    'all': 'All',
    'living_on_property': 'Living on Property',
    'not_living_on_property': 'Not Living on Property',
    'country': 'Country',
    'all_countries': 'All Countries',
    'apartment_status': 'Unit Status',
    'all_statuses': 'All Statuses',
    'with_vacant': 'With Vacant Showroom Units',
    'fully_occupied': 'Fully Occupied',
    'with_maintenance': 'With Maintenance',
    'min_apartments': 'Min. Showroom Units',
    'max_apartments': 'Max. Showroom Units',
    'min_occupancy_rate': 'Min. Occupancy Rate (%)',
    'clear_filters': 'Clear Filters',
    'apply_filters': 'Apply Filters',
    'total_owners': 'Total Owners',
    'resident_owners': 'Resident Owners',
    'with_apartments': 'With Showroom Units',
    'without_apartments': 'Without Showroom Units',
    'loading_owners': 'Loading owners...',
    'error_loading_owners': 'Error Loading Owners',
    'try_again': 'Try Again',
    'no_owners_found': 'No Property Owners Found',
    'no_owners_message': 'There are no property owners in the system yet. Click the \'Add Owner\' button to create your first owner.',
    'create_first_owner': 'Create First Owner',
    'showing_filtered_results': 'Showing {showing} of {total} owners',
    'confirm_deletion': 'Confirm Deletion',
    'delete_owner_confirmation': 'Are you sure you want to delete owner "{name}"? This action cannot be undone.',
    'cancel': 'Cancel',
    'delete': 'Delete',
    'deleting': 'Deleting...',

    'resident_owner': 'Resident Owner',
    'apartments_count': 'Apartemnts Count',
    'show_apartments': 'Show Showroom Units',
    'hide_apartments': 'Hide Showroom Units',
    'size_unit_sqm': 'Unit size square meter',

    "loading": "Loading...",
    "edit_property_owner": "Edit Property Owner",
    "add_property_owner": "Add Property Owner",
    "owner_information": "Owner Information",
    "name": "Name",
    "phone": "Phone",
    "owner_lives_on_property": "Owner lives on the property",
    "preferred_language": "Preferred Language",
    "english": "English",
    "arabic": "Arabic",
    "kurdish": "Kurdish",
    "select_apartments": "Select Showroom Units ({{count}})",
    "available_apartments": "{{count}} available showroom units",
    "no_apartments_available": "No showroom units available. All showroom units already have owners.",
    "floor": "Level",
    "size": "Size",
    "size_unit_sqm": "m²",
    "type": "Type",
    "status": "Status",
    "cancel": "Cancel",
    "saving": "Saving...",
    "update_owner": "Update Owner",
    "create_owner": "Create Owner",
    "failed_to_load_data": "Failed to load data",
    "failed_to_save_owner": "Failed to save owner",


    "activity_logs": "Activity Logs",
    "tenant_activity_logs": "Renter Activity Logs",
    "payment_activity_logs": "Payment Activity Logs",
    "building_activity_logs": "Complex Activity Logs",
    "apartment_activity_logs": "Showroom Unit Activity Logs",
    "owner_activity_logs": "Owner Activity Logs",
    "user_activity_logs": "User Activity Logs",
    "system_activity_logs": "System Activity Logs",
    "track_all_system_activities": "Track all system activities and changes",
    "filter": "Filter",
    "export_to_excel": "Export to Excel",
    "exporting": "Exporting...",
    "search_logs_placeholder": "Search logs by name, user, or details...",
    "showing_entries": "Showing {{showing}} of {{total}} entries",
    "filter_logs": "Filter Logs",
    "action_type": "Action Type",
    "all_actions": "All Actions",
    "entity_type": "Entity Type",
    "all_entities": "All Entities",
    "entries_per_page": "Entries Per Page",
    "start_date": "Start Date",
    "end_date": "End Date",
    "reset": "Reset",
    "apply_filter": "Apply Filter",
    "time": "Time",
    "user": "User",
    "action": "Action",
    "entity": "Entity",
    "details": "Details",
    "view": "View",
    "system": "System",
    "view_entity_details": "View {{type}} details",
    "no_logs_matching_search": "No activity logs matching your search criteria",
    "no_logs_for_filters": "No activity logs found for the selected filters",
    "showing_range": "Showing {{start}} to {{end}} of {{total}} entries",
    "previous": "Previous",
    "next": "Next",
    "failed_to_load_logs": "Failed to load activity logs",
    "failed_to_export_logs": "Failed to export logs to Excel",

    "tenant": "Renter",
    "payment": "Payment",
    "building": "Complex",
    "apartment": "Showroom Unit",
    "owner": "Owner",
    "user": "User",
    "system": "System",

    "created": "Created",
    "updated": "Updated",
    "deleted": "Deleted",
    "viewed": "Viewed",
    "login": "Login",
    "logout": "Logout",
    "payment_made": "Payment Made",
    "payment_received": "Payment Received",
    "status_changed": "Status Changed",
    "approved": "Approved",
    "rejected": "Rejected",
    "maintenance_request": "Maintenance Request",
    "maintenance_completed": "Maintenance Completed",

    "loading_payment_data": "Loading payment data...",
    "error_loading_payment": "Error Loading Payment",
    "payment_not_found": "Payment not found",
    "back_to_payments": "Back to Payments",
    "confirm_deletion": "Confirm Deletion",
    "delete_payment_confirmation": "Are you sure you want to delete this {{amount}} payment? This action cannot be undone.",
    "cancel": "Cancel",
    "deleting": "Deleting...",
    "delete": "Delete",
    "print_receipt": "Print Receipt",
    "edit": "Edit",
    "tenant": "Renter",
    "unknown_tenant": "Unknown Renter",
    "apartment": "Showroom Unit",
    "apt": "Apt",
    "none": "None",
    "payment_period": "Payment Period",
    "payment_details": "Payment Details",
    "tenant_information": "Renter Information",
    "payment_information": "Payment Information",
    "amount": "Amount",
    "payment_date": "Payment Date",
    "payment_type": "Payment Type",
    "created": "Created",
    "last_updated": "Last Updated",
    "notes": "Notes",
    "view_tenant": "View Renter",
    "unknown_period": "Unknown period",
    "to": "to",
    "invalid_period_data": "Invalid period data",
    "unknown_type": "Unknown Type",
    "unknown": "Unknown",
    "failed_to_load_payment_data": "Failed to load payment data",
    "failed_to_delete_payment": "Failed to delete payment",

    "rent": "Rent",
    "service": "Service Fee",
    "deposit": "Deposit",
    "maintenance": "Maintenance",
    "other": "Other",


    "generate": "Generate",
    "generated": "Generated",
    "generate_payment_for": "Generate Payment for",
    "payment_amount": "Payment Amount",
    "enter_amount": "Enter amount",
    "mark_as_paid_immediately": "Mark as paid immediately",
    "notes": "Notes",
    "payment_notes": "Payment notes",
    "required_fields": "Required fields",
    "cancel": "Cancel",
    "generate_payment": "Generate Payment",

    "loading": "Loading...",
    "edit_payment": "Edit Payment",
    "record_payment": "Record Payment",
    "payment_information": "Payment Information",
    "tenant": "Renter",
    "select_tenant": "Select Renter",
    "apt": "Apt",
    "no_apartment": "No Showroom Unit",
    "amount": "Amount",
    "payment_date": "Payment Date",
    "payment_type": "Payment Type",
    "payment_period": "Payment Period",
    "period_start": "Period Start",
    "period_end": "Period End",
    "additional_information": "Additional Information",
    "notes": "Notes",
    "notes_placeholder": "Any additional notes about this payment...",
    "cancel": "Cancel",
    "saving": "Saving...",
    "update_payment": "Update Payment",
    "failed_to_load_tenants_format": "Failed to load renters: unexpected data format",
    "failed_to_load_tenants": "Failed to load renters. Please try again.",
    "failed_to_load_payment_data": "Failed to load payment data",
    "failed_to_save_payment": "Failed to save payment",

    "rent": "Rent",
    "service": "Service Fee",
    "deposit": "Deposit",
    "maintenance": "Maintenance",
    "other": "Other",

    "payments": "Payments",
    "refresh": "Refresh",
    "refresh_payments": "Refresh payments",
    "stats": "Stats",
    "toggle_statistics": "Toggle statistics view",
    "search_payments": "Search payments...",
    "filter": "Filter",
    "record_payment": "Record Payment",
    "confirm_deletion": "Confirm Deletion",
    "confirm_delete_payment": "Are you sure you want to delete the {amount} payment for {tenantName}? This action cannot be undone.",
    "cancel": "Cancel",
    "deleting": "Deleting...",
    "delete": "Delete",
    "filter_payments": "Filter Payments",
    "reset_all": "Reset All",
    "payment_type": "Payment Type",
    "all_types": "All Types",
    "payment_type_rent": "Rent",
    "payment_type_service": "Service",
    "payment_type_deposit": "Deposit",
    "payment_type_other": "Other",
    "building": "Complex",
    "all_buildings": "All Complexes",
    "from_date": "From Date",
    "to_date": "To Date",
    "total_payments": "Total Payments",
    "payment": "payment",
    "payments": "payments",
    "recorded": "recorded",
    "rent_payments": "Rent Payments",
    "service_payments": "Service Payments",
    "payment_statistics": "Payment Statistics",
    "payments_by_month": "Payments by Month",
    "payment_types_distribution": "Payment Types Distribution",
    "recent_activity": "Recent Activity",
    "close_statistics": "Close Statistics",
    "loading_payments": "Loading payments...",
    "this_may_take_moment": "This may take a moment",
    "error_loading_payments": "Error Loading Payments",
    "try_again": "Try Again",
    "no_payments_found": "No Payments Found",
    "no_payments_match_filters": "No payments match your current filters. Try adjusting your filter criteria to see more results.",
    "no_payments_in_system": "There are no payments in the system yet. Get started by recording your first payment.",
    "reset_filters": "Reset Filters",
    "record_first_payment": "Record First Payment",
    "unknown_period": "Unknown period",
    "to": "to",
    "invalid_period_data": "Invalid period data",
    "unknown_type": "Unknown Type",
    "apt": "Apt",
    "print_receipt": "Print receipt",
    "view_details": "View details",
    "edit_payment": "Edit payment",
    "delete_payment": "Delete payment",
    "showing_payments": "Showing {start}-{end} of {total} payments",
    "showing_filtered_payments": "Showing {filtered} of {total} payments based on your search",
    "authentication_required": "Authentication required",
    "failed_load_payments": "Failed to load payments data",
    "auth_failed_login_again": "Authentication failed. Please log in again.",
    "access_denied_admin_required": "Access denied. Admin role required.",
    "server_error_check_backend": "Server error. Please check if the backend is running.",
    "cannot_connect_server": "Cannot connect to server. Please check if backend is running.",
    "error_fetching_payments": "Error fetching payments",
    "error_deleting_payment": "Error deleting payment",
    "failed_delete_payment": "Failed to delete payment",

    "occupancy_report": "Occupancy Report",
    "loading": "Loading...",
    "refresh": "Refresh",
    "back": "Back",
    "error_fetching_occupancy": "Error fetching occupancy data",
    "failed_load_occupancy": "Failed to load occupancy data",
    "occupied": "Occupied",
    "vacant": "Vacant",
    "maintenance": "Maintenance",
    "apartments": "showroom units",
    "occupancy_rate": "Occupancy Rate",
    "of": "of",
    "vacant_apartments": "Vacant Showroom Units",
    "of_total": "of total",
    "maintenance_apartments": "In Maintenance",
    "potential_income": "Potential Monthly Income",
    "buildings": "complexes",
    "occupancy_distribution": "Occupancy Distribution",
    "occupancy_by_building": "Occupancy by Complex",
    "building": "Complex",
    "total_apartments": "Total Showroom Units",
    "print_report": "Print Report",
    "export_report": "Export Report",

    "rent": "Rent",
    "service": "Service",
    "commission": "Commission",
    "insurance": "Insurance",
    "total": "Total",
    "occupied": "Occupied",
    "vacant": "Vacant",
    "maintenance": "Maintenance",
    "apartments": "showroom units",
    "of": "of",
    "excellent": "Excellent",
    "good": "Good",
    "needs_improvement": "Needs Improvement",
    "error_fetching_occupancy": "Error fetching occupancy data",
    "failed_load_occupancy": "Failed to load occupancy data",

    "overdue": "Overdue",
    "pending": "Pending",
    "paid": "Paid",
    "no_overdue_payments": "No overdue payments found",
    "apt": "Apt",
    "days_overdue": "days overdue",
    "more_overdue_tenants": "more overdue renters...",
    "error_fetching_tenant_status": "Error fetching renter payment status",
    "failed_load_tenant_status": "Failed to load renter payment status",

    "rent": "Rent",
    "service": "Service",
    "deposit": "Deposit",
    "no_recent_payments": "No recent payments found",
    "error_fetching_payments": "Error fetching recent payments",
    "failed_load_payments": "Failed to load recent payments",

    "payment_logs": "Payment Logs",
    "filter": "Filter",
    "back": "Back",
    "search_payment_logs_placeholder": "Search payment logs...",
    "showing_entries": "Showing {{showing}} of {{total}} entries",
    "filter_payments": "Filter Payments",
    "time_period": "Time Period",
    "start_date": "Start Date",
    "end_date": "End Date",
    "payment_type": "Payment Type",
    "all_types": "All Types",
    "entries_per_page": "Entries Per Page",
    "reset": "Reset",
    "apply_filter": "Apply Filter",
    "payment_id": "Payment ID",
    "date": "Date",
    "tenant": "Renter",
    "building": "Complex",
    "type": "Type",
    "amount": "Amount",
    "actions": "Actions",
    "print_receipt": "Print Receipt",
    "view_details": "View Details",
    "no_logs_matching_search": "No payment logs matching your search criteria",
    "no_logs_for_period": "No payment logs available for the selected time period",
    "showing_range": "Showing {{start}} to {{end}} of {{total}} entries",
    "previous": "Previous",
    "next": "Next",
    "print_report": "Print Report",
    "export_to_excel": "Export to Excel",
    "failed_to_load_payment_logs": "Failed to load payment logs",

    "current_month": "Current Month",
    "last_month": "Last Month",
    "current_quarter": "Current Quarter",
    "current_year": "Current Year",
    "custom": "Custom Range",

    "rent": "Rent",
    "service": "Service",
    "commission": "Commission",
    "insurance": "Insurance",
    "other": "Other",

    "reports_dashboard": "Reports Dashboard",
    "overview_of_financial_performance": "Overview of financial performance and property statistics",
    "view_all_reports": "View All Reports",
    "failed_to_load_report_data": "Failed to load report data",
    "total_revenue": "Total Revenue",
    "total_payments_count": "{{count}} payments",
    "total_tenants": "Total Renters",
    "new_tenants_this_year": "{{count}} new this year",
    "total_properties": "Total Properties",
    "total_buildings_count": "{{count}} complexes",
    "total_owners": "Total Owners",
    "ended_contracts_count": "{{count}} ended contracts",
    "monthly_revenue_year": "Monthly Revenue - {{year}}",
    "view_details": "View Details",
    "occupancy_rate": "Occupancy Rate",
    "recent_payments": "Recent Payments",
    "view_all": "View All",
    "overdue_payments": "Overdue Payments",
    "quick_reports": "Quick Reports",
    "annual_revenue": "Annual Revenue",
    "yearly_breakdown": "Yearly breakdown of all revenue",
    "building_revenue": "Complex Revenue",
    "revenue_by_building": "Revenue breakdown by complex",
    "owner_revenue": "Owner Revenue",
    "revenue_by_owner": "Revenue breakdown by property owner",
    "payment_logs": "Payment Logs",
    "detailed_payment_history": "Detailed payment history and logs",

    "revenue_report": "Revenue Report",
    "filter": "Filter",
    "loading": "Loading...",
    "refresh": "Refresh",
    "back": "Back",
    "filter_report": "Filter Report",
    "time_period": "Time Period",
    "start_date": "Start Date",
    "end_date": "End Date",
    "cancel": "Cancel",
    "apply_filter": "Apply Filter",
    "failed_to_load_revenue_data": "Failed to load revenue data",
    "total_revenue": "Total Revenue",
    "total_payments_count": "{{count}} payments",
    "rent_revenue": "Rent Revenue",
    "percent_of_total": "{{percent}}% of total",
    "service_revenue": "Service Revenue",
    "unique_tenants": "Unique Renters",
    "avg_per_tenant": "Avg. {{amount}} per renter",
    "revenue_by_building": "Revenue by Complex",
    "view_details": "View Details",
    "building": "Complex",
    "tenants": "Renters",
    "no_building_revenue_data": "No complex revenue data available",
    "revenue_by_owner": "Revenue by Owner",
    "owner": "Owner",
    "apartments": "Showroom Units",
    "no_owner_revenue_data": "No owner revenue data available",
    "print_report": "Print Report",
    "export_report": "Export Report",

    "current_month": "Current Month",
    "last_month": "Last Month",
    "current_quarter": "Current Quarter",
    "current_year": "Current Year",
    "custom": "Custom Range",

    "service_payments_management": "Service Payments Management",
    "refresh": "Refresh",
    "back_to_dashboard": "Back to Dashboard",
    "building": "Complex",
    "select_building": "Select Complex",
    "year": "Year",
    "search": "Search",
    "search_apartments_tenants": "Search showroom units, renters...",
    "generate_payments": "Generate Payments",
    "view_statistics": "View Statistics",
    "filter_by_status": "Filter by status",
    "all": "All",
    "paid": "Paid",
    "unpaid": "Unpaid",
    "clear_filters": "Clear Filters",
    "loading_service_data": "Loading service payment data...",
    "no_building_selected": "No Complex Selected",
    "please_select_building": "Please select a complex to view service payments.",
    "no_search_results": "No Search Results",
    "no_matching_apartments": "No showroom units or renters match your search criteria.",
    "service_payments_for_building_year": "Service Payments for {{building}} - {{year}}",
    "floor_number": "Zone {{number}}",
    "apartments": "Showroom Units",
    "rate": "Rate",
    "tenant_owner": "Renter/Owner",
    "vacant": "Vacant",
    "mark_as_paid": "Mark as Paid",
    "mark_as_unpaid": "Mark as Unpaid",
    "view_details": "View Details",
    "summary": "Summary",
    "floor_apartment_count": "{{floors}} zones, {{showrooms}} showroom units",
    "zone_showroom_count": "{{zones}} zones, {{showrooms}} showroom units",
    "no_floors_available": "No Levels Available",
    "no_floors_message": "There are no levels with showroom units in this complex, or no service payments have been generated yet.",
    "failed_to_load_buildings": "Failed to load complexes. Please try again.",
    "failed_to_load_floors": "Failed to load levels",
    "failed_to_load_building_floors": "Failed to load complex levels",
    "failed_to_load_floor_data": "Failed to load level data",
    "data_refreshed_successfully": "Data refreshed successfully.",
    "failed_to_refresh_data": "Failed to refresh data",
    "marked_as_paid_via_service_management": "Marked as paid via service management",
    "marked_as_unpaid_via_service_management": "Marked as unpaid via service management",
    "payment_marked_as_paid": "Payment marked as paid successfully.",
    "payment_marked_as_unpaid": "Payment marked as unpaid successfully.",
    "failed_to_update_payment": "Failed to update payment",
    "payment_details": "Payment Details",
    "payment_due": "Payment Due",
    "amount": "Amount",
    "status": "Status",
    "paid_on": "Paid on",
    "no_apartments_on_floor": "No showroom units found on this level.",

    "month_1": "January",
    "month_2": "February",
    "month_3": "March",
    "month_4": "April",
    "month_5": "May",
    "month_6": "June",
    "month_7": "July",
    "month_8": "August",
    "month_9": "September",
    "month_10": "October",
    "month_11": "November",
    "month_12": "December",


    "service_payment_details": "Service Payment Details",
    "print_receipt": "Print Receipt",
    "loading": "Loading...",
    "failed_to_load_payment_details": "Failed to load payment details",
    "api_endpoint_missing_message": "This error indicates a missing API endpoint on your backend server. To fix this, add a route for GET /api/services/:id in your serviceRoutes.js file.",
    "payment_information": "Payment Information",
    "apartment": "Showroom Unit",
    "period": "Period",
    "amount": "Amount",
    "status": "Status",
    "tenant": "Renter",
    "owner": "Owner",
    "payment_date": "Payment Date",
    "paid_by": "Paid By",
    "notes": "Notes",
    "update_payment": "Update Payment",
    "mark_as_paid": "Mark as Paid",
    "currency": "Currency",
    "select_payer": "Select Payer",
    "management": "Management",
    "other": "Other",
    "payment_notes_placeholder": "Enter any additional notes about this payment...",
    "cancel": "Cancel",
    "saving": "Saving...",
    "payment_history": "Payment History",
    "date": "Date",
    "action": "Action",
    "by": "By",
    "paid": "Paid",
    "unpaid": "Unpaid",
    "payment_marked_as_paid": "Payment successfully marked as paid.",
    "payment_marked_as_unpaid": "Payment successfully marked as unpaid.",
    "failed_to_update_payment": "Failed to update payment",
    "service_payment_receipt": "Service Payment Receipt",
    "property_management": "Property Management",
    "receipt_generated": "This receipt was generated on {{date}} at {{time}}",
    "automated_receipt_notice": "This is an automatically generated receipt and does not require a signature.",
    "us_dollar": "US Dollar",
    "iraqi_dinar": "Iraqi Dinar",
    "euro": "Euro",

    "month_1": "January",
    "month_2": "February",
    "month_3": "March",
    "month_4": "April",
    "month_5": "May",
    "month_6": "June",
    "month_7": "July",
    "month_8": "August",
    "month_9": "September",
    "month_10": "October",
    "month_11": "November",
    "month_12": "December",

    "tenant": "renter",
    "owner": "owner",
    "management": "management",
    "other": "other",

    "generate_service_payments": "Generate Service Payments",
    "recipients": "Recipients",
    "entire_building": "Entire Complex",
    "generate_for_all_apartments": "Generate for all showroom units in a complex",
    "specific_tenants": "Specific Renters",
    "generate_for_selected_tenants": "Generate for selected renters only",
    "specific_owners": "Specific Owners",
    "generate_for_selected_owners": "Generate for selected owners only",
    "select_building": "Select Complex",
    "include_vacant_apartments": "Include vacant showroom units",
    "selected_tenants": "Selected Renters",
    "selected_owners": "Selected Owners",
    "select_tenants": "Select Renters",
    "select_owners": "Select Owners",
    "no_tenants_selected": "No renters selected",
    "no_owners_selected": "No owners selected",
    "payment_details": "Payment Details",
    "amount": "Amount",
    "currency": "Currency",
    "us_dollar": "US Dollar",
    "iraqi_dinar": "Iraqi Dinar",
    "euro": "Euro",
    "initial_status": "Initial Status",
    "unpaid": "Unpaid",
    "paid": "Paid",
    "notes": "Notes",
    "payment_notes_placeholder": "Enter any additional notes about these payments...",
    "time_period": "Time Period",
    "generation_type": "Generation Type",
    "single_month": "Single Month",
    "multiple_months": "Multiple Months",
    "month_range": "Month Range",
    "year": "Year",
    "month": "Month",
    "select_months": "Select Months",
    "from": "From",
    "to": "To",
    "selected_months": "Selected Months",
    "payment_generation_summary": "Payment Generation Summary",
    "all_apartments_in": "All showroom units in",
    "selected_building": "selected complex",
    "tenants": "renters",
    "owners": "owners",
    "cancel": "Cancel",
    "generating": "Generating...",
    "generate_payments": "Generate Payments",
    "search": "Search",
    "search_by_tenant_name_or_phone": "Search by renter name, phone or showroom unit number...",
    "search_by_owner_name_or_phone": "Search by owner name or phone...",
    "no_results_found": "No results found",
    "selected": "selected",
    "done": "Done",
    "no_tenants_available": "No renters available. Please add renters first.",
    "no_owners_available": "No owners available. Please add owners first.",
    "apt": "Apt",
    "january": "January",
    "february": "February",
    "march": "March",
    "april": "April",
    "may": "May",
    "june": "June",
    "july": "July",
    "august": "August",
    "september": "September",
    "october": "October",
    "november": "November",
    "december": "December",
    "failed_to_load_buildings": "Failed to load complexes. Please try again.",
    "failed_to_load_tenants": "Failed to load renters. Please try again.",
    "failed_to_load_owners": "Failed to load owners. Please try again.",
    "please_select_building": "Please select a complex",
    "please_select_at_least_one_recipient": "Please select at least one {{recipient}}",
    "please_enter_valid_amount": "Please enter a valid amount",
    "please_select_month": "Please select a month",
    "please_select_at_least_one_month": "Please select at least one month",
    "end_month_must_be_after_start_month": "End month must be after start month",
    "successfully_generated_payments": "Successfully generated {{count}} service payments across {{months}} month(s). {{skipped}} payments were already generated.",
    "failed_to_generate_service_payments": "Failed to generate service payments",
    "tenant": "renter",
    "owner": "owner",

    "service_payment_statistics": "Service Payment Statistics",
    "back_to_services": "Back to Services",
    "building": "Complex",
    "year": "Year",
    "loading_statistics": "Loading statistics...",
    "no_building_selected": "No Complex Selected",
    "please_select_building_statistics": "Please select a complex to view service payment statistics.",
    "overall_statistics": "Overall Statistics",
    "total_collection": "Total Collection",
    "of": "of",
    "payment_rate": "Payment Rate",
    "payments": "payments",
    "outstanding_amount": "Outstanding Amount",
    "unpaid_payments": "unpaid payments",
    "monthly_statistics": "Monthly Statistics",
    "no_monthly_data": "No monthly data available for the selected year.",
    "month": "Month",
    "total_amount": "Total Amount",
    "collected": "Collected",
    "outstanding": "Outstanding",
    "progress": "Progress",
    "failed_to_load_service_statistics": "Failed to load service statistics",

    "loading_tenant_data": "Loading renter data...",
    "error_loading_tenant": "Error Loading Renter",
    "tenant_not_found": "Renter not found",
    "back_to_tenants": "Back to Renters",
    "record_payment": "Record Payment",
    "edit": "Edit",
    "status_unknown": "Status Unknown",
    "apartment": "Showroom Unit",
    "apt": "Apt",
    "none": "None",
    "monthly_rent": "Monthly Rent",
    "payment_date": "Payment Date",
    "overview": "Overview",
    "leases": "Leases",
    "payments": "Payments",
    "contact_information": "Contact Information",
    "lease_information": "Lease Information",
    "contract_period": "Contract Period",
    "rent": "Rent",
    "discount": "Discount",
    "rent_after_discount": "Rent After Discount",
    "additional_fees": "Additional Fees",
    "service_fee": "Service Fee",
    "office_commission": "Office Commission",
    "insurance": "Insurance",
    "notes": "Notes",
    "no_leases": "No Leases",
    "no_leases_message": "This renter has no showroom unit assigned yet.",
    "active_leases": "Active Leases",
    "inactive_leases": "Inactive Leases",
    "active": "Active",
    "ended": "Ended",
    "expiring_soon": "Expiring soon",
    "end_lease": "End lease",
    "start_date": "Start Date",
    "end_date": "End Date",
    "duration": "Duration",
    "remaining": "Remaining",
    "months": "months",
    "security_deposit": "Security Deposit",
    "total_value": "Total Value",
    "no_payments": "No Payments",
    "no_payments_message": "This renter has no recorded payments yet.",
    "record_first_payment": "Record First Payment",
    "payment_period": "Payment Period",
    "reference": "Reference",
    "payment_type": "Payment Type",
    "rent_payment": "Rent Payment",
    "additional_fee": "Additional Fee",
    "utility_payment": "Utility Payment",
    "other_payment": "Other Payment",
    "start": "Start",
    "end": "End",
    "reference_number": "Reference Number",
    "cancel": "Cancel",
    "unknown_period": "Unknown period",
    "invalid_period_format": "Invalid period format",
    "to": "to",
    "invalid_period_data": "Invalid period data",
    "please_enter_valid_payment_amount": "Please enter a valid payment amount",
    "end_date_must_be_after_start_date": "End date must be after start date",
    "failed_to_add_payment": "Failed to add payment",
    "maintenance_requests_not_supported": "Maintenance requests are not supported in the current database structure",
    "failed_to_create_maintenance_request": "Failed to create maintenance request",
    "confirm_end_lease": "Are you sure you want to end this lease? This action cannot be undone.",
    "lease_ended_by_administrator": "Lease ended by administrator",
    "failed_to_end_lease": "Failed to end lease",
    "failed_to_load_tenant_data": "Failed to load renter data",
    "actual_end_date": "Actual End Date",

    "edit_tenant": "Edit Renter",
    "add_tenant": "Add Renter",
    "basic_information": "Basic Information",
    "first_name": "First Name",
    "last_name": "Last Name",
    "email": "Email",
    "phone": "Phone",
    "apartment": "Showroom Unit",
    "select_apartment": "Select Showroom Unit",
    "floor": "Level",
    "rent_amount": "Rent Amount",
    "discount": "Discount",
    "service_fee": "Service Fee",
    "office_commission": "Office Commission",
    "insurance": "Insurance",
    "contract_start_date": "Contract Start Date",
    "contract_end_date": "Contract End Date",
    "payment_date": "Payment Date",
    "payment_end_date": "Payment End Date",
    "rent_status": "Rent Status",
    "additional_information": "Additional Information",
    "notes": "Notes",
    "tenant_notes_placeholder": "Any additional notes about this renter...",
    "cancel": "Cancel",
    "saving": "Saving...",
    "update_tenant": "Update Renter",
    "create_tenant": "Create Renter",
    "loading": "Loading...",
    "failed_to_load_tenant_data": "Failed to load renter data",
    "failed_to_save_tenant": "Failed to save renter",
    "pending": "Pending",
    "paid": "Paid",
    "late": "Late",
    "overdue": "Overdue",
    "unpaid": "Unpaid",

    "tenants": "Renters",
    "refresh_tenants": "Refresh renters",
    "selected": "selected",
    "delete_selected_tenants": "Delete selected renters",
    "search_tenants": "Search renters...",
    "filter": "Filter",
    "switch_to_list_view": "Switch to List View",
    "switch_to_grid_view": "Switch to Grid View",
    "list_view": "List",
    "grid_view": "Grid",
    "hide_inactive_tenants": "Hide inactive renters",
    "show_inactive_tenants": "Show inactive renters",
    "hide_inactive": "Hide Inactive",
    "show_inactive": "Show Inactive",
    "add_tenant": "Add Renter",
    "rent_status": "Rent Status",
    "all_statuses": "All Statuses",
    "all_buildings": "All Complexes",
    "all_apartments": "All Showroom Units",
    "min_rent": "Min Rent",
    "max_rent": "Max Rent",
    "unlimited": "Unlimited",
    "contracts_ending_before": "Contracts Ending Before",
    "clear_filters": "Clear Filters",
    "apply_filters": "Apply Filters",
    "active_tenants": "Active Renters",
    "inactive_tenants": "Inactive Renters",
    "with_apartments": "With Showroom Units",
    "without_apartments": "Without Showroom Units",
    "loading_tenants": "Loading renters...",
    "error_loading_tenants": "Error Loading Renters",
    "try_again": "Try Again",
    "no_tenants_found": "No Renters Found",
    "no_tenants_message": "There are no renters in the system yet. Click the 'Add Renter' button to create your first renter.",
    "create_first_tenant": "Create First Renter",
    "page": "page",
    "showing_items": "Showing {start}-{end} of {total}",
    "first_page": "First Page",
    "previous_page": "Previous Page",
    "next_page": "Next Page",
    "last_page": "Last Page",
    "showing_filtered_results": "Showing {showing} of {total} renters",
    "confirm_deletion": "Confirm Deletion",
    "delete_tenant_confirmation": "Are you sure you want to delete renter \"{name}\"? This action cannot be undone.",
    "cancel": "Cancel",
    "deleting": "Deleting...",
    "delete": "Delete",
    "tenant": "Renter",
    "apartment": "Showroom Unit",
    "rent": "Rent",
    "contract": "Contract",
    "status": "Status",
    "actions": "Actions",
    "apt": "Apt",
    "unknown_building": "Unknown Complex",
    "no_apartment_assigned": "No showroom unit assigned",
    "status_unknown": "Status Unknown",
    "monthly_rent": "Monthly Rent",
    "after_discount": "After Discount",
    "payment_date": "Payment Date",
    "not_set": "Not set",
    "contract_start": "Contract Start",
    "contract_end": "Contract End",
    "service": "Service",
    "commission": "Commission",
    "insurance": "Insurance",
    "hide_owner_details": "Hide Owner Details",
    "works_at_showroom": "Works at Showroom",
    "show_owner_details": "Show Owner Details",
    "apartment_owner": "Showroom Unit Owner",
    "loading_owner_details": "Loading owner details...",
    "no_owner_information": "No owner information available",
    "lives_on_property": "Works in There",
    "yes": "Yes",
    "no": "No",
    "total_apartments": "Total Showroom Units",
    "monthly_service_fee_applies": "Monthly service fee applies",
    "apartment_details": "Showroom Unit Details",
    "apartment_number": "Showroom Unit #",
    "unknown": "Unknown",
    "floor": "Level",
    "apartment_type": "Unit Type",
    "standard": "Standard",
    "furnished": "Has Utilities",
    "view_owner_profile": "View Owner Profile",
    "mark_as_inactive": "Mark as inactive",
    "mark_as_active": "Mark as active",
    "record_payment": "Record payment",
    "view_details": "View details",
    "edit_tenant": "Edit Renter",
    "delete_tenant": "Delete renter",
    "to": "To",
    "payment": "Payment",
    "apartment_financial_details": "Showroom Unit & Financial Details",
    "not_authenticated": "Not authenticated. Please log in.",
    "authentication_required": "Authentication required",
    "authentication_failed": "Authentication failed. Please log in again.",
    "access_denied": "Access denied. Admin role required.",
    "server_error": "Server error. Please check if the backend is running.",
    "cannot_connect_to_server": "Cannot connect to server. Please check if backend is running on port 3000.",
    "failed_to_load_tenants_data": "Failed to load renters data",
    "failed_to_load_client_data": "Failed to load client data",
    "unknown_error": "Unknown error",
    "failed_to_delete_tenant": "Failed to delete renter",
    "confirm_bulk_delete": "Are you sure you want to delete {count} renters? This action cannot be undone.",
    "failed_to_delete_tenants": "Failed to delete renters",
    "failed_to_update_tenant_status": "Failed to update Renter status",
    "pending": "Pending",
    "paid": "Paid",
    "late": "Late",
    "overdue": "Overdue",

    'add_new_user': 'Add New User',
    'search_users': 'Search Users',
    'total_users': 'Total Users',
    'active_users': 'Active Users',
    'inactive_users': 'Inactive Users',
    'financial_summary': 'Financial Summary',
    'filters': 'Filters',
    'search_tenants_placeholder': 'Search Renter by Name, Phone, or Showroom Unit',
    'terminate_contract': 'Terminate Contract',
    'terminate_confirmation_desc': 'Are you sure you want to terminate the active logistics contract for this client? This will immediately free up the unit.',
    'active_tenants': 'Active Renters',
    'inactive_tenants': 'Inactive Renters',
    'with_apartments': 'with Showroom Units',
    'without_apartments': 'without Showroom Units',
    'tenants_management': 'Renter Management',
    'manage_tenants_and_leases': 'Manage Renters and Contracts',
    'add_tenant': 'Add Renter',
    'terminating': 'Terminating...',
    'terminate': 'Terminate',
    'loading_client_profile': 'Loading Client Profile...',
    'profile_error': 'Profile Error',
    'client_not_found': 'Client entity not found.',
    'back_to_roster': 'Back to Roster',
    'contract_ended': 'Contract Ended',
    'unit_number_display': 'Unit {{number}}',
    'block_number_display': '(Block {{number}})',
    'contract_information': 'Contract Information',
    'extend': 'Extend',
    'relocate': 'Relocate',
    'renew_contract': 'Renew Contract',
    'extend_contract': 'Extend Contract',
    'current_end_date': 'Current End Date',
    'new_end_date': 'New End Date',
    'confirm_extension': 'Confirm Extension',
    'finalize_transaction': 'Submit Ledger',
    'extending_contract': 'Extending Contract...',
    'terminated': 'Terminated',
    'from': 'From',
    'expiring_soon_label': 'Expiring Soon',
    'preferred_language': 'Preferred Language',
    'english': 'English',
    'arabic': 'Arabic',
    'kurdish': 'Kurdish',
    'tenant_notes_placeholder': 'Enter notes for this renter...',
    'configure': 'Configure',
    'renter': 'Renter',
    'renters': 'Renters',
    'showroom_unit': 'Showroom Unit',
    'complex': 'Logistics Complex',
    'active_unit': 'Active Unit',
    'status_override': 'Status Override',
    'force_status_change': 'Force Status Change',
    'complex_zoning': 'Complex & Zoning',
    'block_zone': 'Block / Zone',
    'showroom_specifications': 'Showroom Specifications',
    'class_type': 'Class Type',
    'internal_size': 'Internal Size',
    'utilities_active': 'Utilities Active',
    'owner_investor_details': 'Owner / Investor Details',
    'entity_name': 'Entity Name',
    'contact_number': 'Contact Number',
    'future_client_upcoming': 'Future Client (Upcoming)',
    'active_client': 'Active Client',
    'contract_specs': 'Contract Specs',
    'net_effective': 'Net Effective',
    'system_timestamps': 'System Timestamps',
    'queue_holds': 'Queue & Holds',
    'historical_ledger': 'Historical Ledger',
    'historical_ledger_desc': 'Past client contracts attached to this unit.',
    'final_balance': 'Final Balance',
    'archive': 'Archive',
    'notice': 'Notice',
    'try_again': 'Try Again',
    'back': 'Back',
    'showroom_not_found_desc': 'The unit you are looking for does not exist or has been removed.',
    'confirm_deletion': 'Confirm Deletion',
    'delete_unit': 'Delete Unit',
    'unknown_complex': 'Unknown Complex',
    'rented_sold': 'Rented / Sold',
    'contract_expired': 'Contract Expired',
    'yes_pwr_clim': 'Yes (Pwr/Clim)',
    'none': 'None',
    'view_client_profile': 'View Client Profile',
    'acct_status': 'Acct Status',
    'logged_on': 'Logged On',
    'last_modification': 'Last Modification',
    'log_new_hold': 'Log New Hold',
    'view_full_queue': 'View Full Queue',
    'log_new_client': 'Log New Client',
    'access_client_data': 'Access Client Data',
    'clear_maintenance': 'Clear Maintenance',
    'return_to_complex': 'Return to Complex',
    'configure_unit': 'Configure Unit',
    'critical_contract_expired': 'Critical: Contract Expired',
    'resolve_contract': 'Resolve Contract',
    'entity': 'Entity',
    'contract_period': 'Contract Period',
    'payment_type_commission': 'Commission',
    'day': 'Day',
    'lapsed_on': 'Lapsed On',
    'secured_by_client': 'Currently secured by a client.',
    'available_for_logging': 'Free and available for logging.',
    'locked_for_maintenance': 'Slot locked for maintenance.',
    'no_active_queue': 'No active queue or holds for this unit.',
    'contract_lapsed_desc': 'The logistics contract for {{name}} has lapsed and requires immediate renewal or termination.',
    'revenue_breakdown_desc': 'View revenue breakdown by user for a specific month',
    'indefinite': 'Indefinite',
    'contract_exceeded_desc': 'Contract has exceeded end date.',
    'command_center': 'Command Center',
    'no_historical_records': 'No historical records found.',
    'no_phone': 'No phone',
    'view': 'View',
    'base_rate': 'Base Rate',
    'billing_cycle': 'Billing Cycle',
    'ledger_debt': 'Ledger Debt',
    'clear_until': 'Clear Until',
    'not_set': 'Not Set',
    'entity_profile': 'Entity Profile',
    'active_contracts': 'Active Contracts',
    'financial_ledger': 'Financial Ledger',
    'entity_contacts': 'Entity Contacts',
    'email_address': 'Email Address',
    'primary_phone': 'Primary Phone',
    'comm_language': 'Comm. Language',
    'base_contract_details': 'Base Contract Details',
    'valid_window': 'Valid Window',
    'unknown_period': 'Unknown Period',
    'invalid_format': 'Invalid Format',
    'invalid_data': 'Invalid Data',
    'contract_extended_success': 'Contract extended successfully',
    'contract_renewed_success': 'Contract renewed successfully',
    'relocated_success': 'Client relocated successfully',
    'months': 'months',
    'term_months': '{{count}} months',
    'please_enter_valid_payment_amount': 'Please enter a valid payment amount',
    'end_date_must_be_after_start_date': 'End date must follow start date',
    'failed_to_add_payment': 'Failed to add payment',
    'failed_to_terminate_contract': 'Failed to terminate contract',
    'failed_to_relocate_client': 'Failed to relocate client',
    'valid_window': 'Valid Window',
    'to': 'to',
    'gross_rate': 'Gross Rate',
    'applied_discount': 'Applied Discount',
    'net_effective_rate': 'Net Effective Rate',
    'surcharges_deposits': 'Surcharges & Deposits',
    'service_fee': 'Service Fee',
    'commission': 'Commission',
    'sec_deposit': 'Sec. Deposit',
    'entity_notes': 'Entity Notes',
    'contract_registry': 'Contract Registry',
    'logs_count': '({{count}} Logs)',
    'no_contracts_found': 'No Contracts Found',
    'no_contracts_desc': 'This entity has no active or historical contracts attached.',
    'historical_contracts': 'Historical Contracts',
    'ended': 'Ended',
    'valid_from': 'Valid From',
    'valid_to': 'Valid To',
    'total_term': 'Total Term',
    'remaining': 'Remaining',
    'total_value': 'Total Value',
    'log_payment': 'Log Payment',
    'months': 'Months',
    'expiring_soon_label': 'Expiring Soon',
    'terminated': 'Terminated',
    'from': 'From',

    'view_profile': 'View Profile',

    // WhatsApp Settings
    'whatsapp_settings': 'WhatsApp Settings',
    'whatsapp_settings_description': 'Automated WhatsApp notifications for renters and owners',
    'whatsapp_enable': 'Enable WhatsApp Notifications',
    'whatsapp_enable_sub': 'Turn all automated WhatsApp messages on or off',
    'general_settings': 'General Settings',
    'default_country_code': 'Default Country Code',
    'tenant_rent_reminder': 'Renter Rent Reminder',
    'tenant_rent_reminder_sub': 'Send reminder to renters before or after payment due date',
    'days_before_due': 'Days Before Due',
    'reminder_message_template': 'Message Template',
    'service_fee_reminder': 'Service Fee Reminder',
    'enable_service_fee_reminder': 'Enable Service Fee Reminder',
    'service_fee_reminder_sub': 'Notify renters about upcoming service fee payments',
    'owner_reminder': 'Owner Reminder',
    'enable_owner_reminders': 'Enable Owner Reminders',
    'owner_reminder_sub': 'Notify owners when their renters have overdue payments',
    'owner_message_template': 'Owner Message Template',
    'payment_confirmation': 'Payment Confirmation',
    'send_on_payment': 'Send confirmation when payment is recorded',
    'payment_confirmation_sub': 'Automatically sent to renter when a payment is logged',
    'payment_confirmation_template': 'Confirmation Message Template',
    'whatsapp_test_send': 'Send Test Message',
    'test_message': 'Message',
    'send_test_message': 'Send Test Message',
    'whatsapp_test_sent': 'Test message sent!',
    'whatsapp_test_default_message': 'Test message from property management system',
    'send_reminders_now': 'Send Reminders Now',
    'send_reminders_now_description': 'Immediately send reminders to all renters and owners who need one right now.',
    'whatsapp_must_be_enabled': 'WhatsApp must be enabled first',
    'failed_to_load_settings': 'Failed to load settings',
    'settings_saved': 'Settings saved successfully',
    'failed_to_save': 'Failed to save',
    'failed_to_send': 'Failed to send',
    'server_error': 'Server connection error',
    'sent': 'Sent',
    'errors': 'Errors',
    'skipped': 'Skipped',

    // Bookings
    'bookings': 'Bookings',
    'booking_management': 'Booking Management',
    'new_booking': 'New Booking',
    'create_booking': 'Create Booking',
    'edit_booking': 'Edit Booking',
    'booking_details': 'Booking Details',
    'prospect': 'Prospect',
    'prospect_name': 'Prospect Name',
    'prospect_phone': 'Phone Number',
    'prospect_email': 'Email Address',
    'move_in_date': 'Move-in Date',
    'move_out_date': 'Move-out Date',
    'hold_duration': 'Hold Duration',
    'hold_hours': 'Hold Hours',
    'hold_expiration': 'Hold Expiration',
    'internal_notes': 'Internal Notes',
    'check_availability': 'Check Availability',
    'checking_availability': 'Checking availability...',
    'no_bookings_found': 'No bookings found',
    'calendar_view': 'Calendar View',
    'waitlist': 'Waitlist',
    'new_booking_hold': 'New Booking Hold',
    'property_information': 'Property Information',
    'prospect_details': 'Prospect Details',
    'requested_dates': 'Requested Dates',
    'conflict_detected': 'Conflict Detected',
    'booking_timeline': 'Booking Timeline',
    'monthly_view_holds': 'Monthly view of active showroom unit holds',
    'confirmed_hold': 'Confirmed Hold',
    'pending_payment': 'Pending Payment',
    'move_in': 'Move-In',
    'move_out': 'Move-Out',
    'convert_to_tenant': 'Convert to Renter',
    'confirm_booking': 'Confirm Booking',
    'cancel_booking': 'Cancel Booking',
    'booking_confirmed': 'Booking confirmed',
    'booking_cancelled': 'Booking cancelled',
    'booking_converted': 'Successfully converted booking to renter!',
    'process_to_booking': 'Process to Booking',
    'waitlist_management': 'Waitlist Management',
    'waitlist_empty': 'Waitlist is empty',
    'search_waitlist': 'Search waitlist...',
    'priority': 'Priority',
    'desired_unit': 'Desired Unit',
    'move_in_preference': 'Move-in Preference',
    'added': 'Added',
    'rank': 'Rank',
    'process_waitlist_success': 'Successfully converted to a pending booking!',
    'remove_from_waitlist': 'Are you sure you want to remove this entry from the waitlist?',
    'entry_removed': 'Entry removed',
    'hold_expires': 'Hold Expires',
    'hours': 'Hours',
    'optional': 'Optional',
    'apartment_element': 'Showroom Unit Element',
    'select_unit': 'Select Unit',
    'error_loading_data': 'Failed to load data',
    'error_saving_booking': 'Error saving booking',
    'save_changes': 'Save Changes',
    'select_apartment_move_in_date_error': 'Please select an showroom unit and move-in date to check availability',
    'apartment_available': 'Showroom Unit is available for these dates!',
    'error_checking_availability': 'Error checking availability',
    'confirm_conflict_booking': 'There are date conflicts. Are you sure you want to proceed?',
    'booking_updated': 'Booking updated successfully',
    'booking_number': 'Booking #{{id}}',
    'created_at': 'Created {{date}}',
    'created_by': 'by {{name}}',
    'system': 'System',
    'confirm': 'Confirm',
    'target_property': 'Target Property',
    'furnished': 'Has Utilities',
    'unfurnished': 'No Utilities',
    'booking_window': 'Booking Window',
    'indefinite': 'Indefinite',
    'created_source': 'Created ({{source}})',
    'view_tenant_profile': 'View Renter Profile',
    'convert_to_active_tenant': 'Convert to Active Renter',
    'lease_details_move_in_instruction': 'Complete the following lease details to move {{name}} into Unit {{unit}}.',
    'monthly_rent': 'Monthly Rent',
    'first_payment_date': 'First Payment Date',
    'contract_start': 'Contract Start',
    'contract_end': 'Contract End',
    'confirm_convert': 'Confirm & Convert',
    'confirm_booking_question': 'Are you sure you want to confirm this booking?',
    'reason_optional': 'Please provide a reason (optional):',
    'amount': 'Amount',
    'today': 'Today',
    'sun': 'Sun',
    'mon': 'Mon',
    'tue': 'Tue',
    'wed': 'Wed',
    'thu': 'Thu',
    'fri': 'Fri',
    'sat': 'Sat',
    'more': 'More',
    'close': 'Close',
    'hold_expiration': 'Hold Expiration',
    'view_details': 'View Details',
    'waitlist_management': 'Waitlist Management',
    'search_waitlist': 'Search waitlist...',
    'waitlist_empty': 'Waitlist is empty',
    'no_prospective_tenants_waiting': 'No prospective renters are currently waiting for showroom unit availability.',
    'priority': 'Priority',
    'rank': 'Rank: {{priority}}',
    'desired_unit': 'Desired Unit',
    'move_in_preference': 'Move-in Preference',
    'process_to_booking': 'Process to Booking',
    'remove': 'Remove',
    'remove_waitlist_confirm': 'Are you sure you want to remove this entry from the waitlist?',
    'waitlist_processed': 'Successfully converted to a pending booking!',
    'entry_removed': 'Entry removed',
    'failed_process_waitlist': 'Failed to process waitlist entry',
    'failed_remove_entry': 'Failed to remove entry',
    'booking_analytics': 'Booking Analytics',
    'track_conversion_and_holds': 'Track conversion rates and hold durations',
    'last_7_days': 'Last 7 Days',
    'last_30_days': 'Last 30 Days',
    'last_90_days': 'Last 90 Days',
    'last_year': 'Last Year',
    'total_bookings': 'Total Bookings',
    'in_selected_period': 'In selected period',
    'conversion_rate': 'Conversion Rate',
    'converted_to_tenants': '{{count}} converted to renters',
    'cancellation_rate': 'Cancellation Rate',
    'cancelled_holds': '{{count}} cancelled holds',
    'avg_hold_time': 'Avg Hold Time',
    'before_conversion_cancel': 'Before conversion/cancel',
    'volume_trends': 'Volume Trends',
    'no_trend_data': 'No trend data available',
    'total_holds': 'Total Holds',
    'status_breakdown': 'Status Breakdown',
    'no_status_data': 'No status data available',
    'active_holds': 'Active Holds',
    'overdue_rent': 'Overdue Rent',
    'subscription': 'Subscription',
    'whatsapp': 'WhatsApp',
    'apartment_unit_display': 'Showroom Unit {{number}} - Level {{level}}',
    'building_view': 'Complex View',
    'showing_all_apartments': 'Showing all showroom units',
    'expand_all_floors': 'Expand all levels',
    'expand_all_rows': 'Expand All Rows',
    'collapse_all_floors': 'Collapse all levels',
    'collapse_all_rows': 'Collapse All Rows',
    'pending_move_in': 'Pending Move-in',
    'tenant_name': 'Name',
    'tenant_phone': 'Phone',
    'tenant_email': 'Email',
    'lease_details': 'Lease Details',
    'start_date': 'Start Date',
    'end_date': 'End Date',
    'monthly_pay_date': 'Monthly Pay Date',
    'day_number': 'Day {{number}}',
    'duration': 'Duration',
    'months': 'Months',
    'remaining_time': 'Remaining Time',
    'financial_summary': 'Financial Summary',
    'monthly_rent': 'Monthly Rent',
    'effective_rent': 'Effective Rent',
    'rent_status': 'Rent Status',
    'future_tenant_upcoming_move_in': 'Future Renter (Upcoming Move-In)',
    'move_in_date': 'Move-In Date',
    'contract_end': 'Contract End',
    'recent_bookings': 'Recent Bookings & Holds',
    'new_hold': 'New Hold',
    'available_now': 'Available Now',
    'lease_ending_soon': 'Lease Ending Soon',
    'no_apartments_found': 'No suitable showroom units found',
    'ready': 'Ready',
    'ends_in_days': 'Ends in {{count}}d',
    'search_unit': 'Search showroom unit...',
    'currently_occupied': 'Currently Occupied',
    'occupied': 'Occupied',
    'all_service_payments': 'All Service Payments',
    'manage_all_service_payments_across_buildings': 'Manage all service payments across complexes',
    'tenants_management': 'Renters Management',
    'manage_tenants_and_leases': 'Manage renters and leases',
    'past_tenants': 'Past Renters',
    'lease_ended': 'Lease Ended',
    'end_lease_confirm_title': 'Confirm End of Lease',
    'end_lease_confirm_body': 'Are you sure you want to end this lease?',
    'no_past_tenants': 'No past renters',
    'sign_up_to_get_started': 'Sign up to get started',
    'company_name': 'Company Name',
    'already_have_account': 'Already have an account?',
    'status_expired_description': 'This lease has expired. No further payments can be applied.',
    'lease_expired_warning': 'This lease has expired.',
    'tenant_lease_expired_message': 'No further payments can be applied.',
    'expired_on': 'Expired on',
    'manage_tenant': 'Manage Renter',
    'move_in_pending': 'Move-in Pending',
    'lease_expired': 'Lease Expired',
    'create_hold': 'Create Hold',
    'billing_subscription': 'Billing & Subscription',
    'current_plan': 'Current Plan',
    'subscribe_now': 'Subscribe Now',
    'manage_your_subscription_and_billing': 'Manage your subscription and billing',
    'view_payment_logs': 'View Payment Logs',
    'view_activity_logs': 'View Activity Logs',
    'view_revenue_report': 'View Revenue Report',
    'view_occupancy_report': 'View Occupancy Report',
    'view_tenant_logs': 'View Renter Logs',
    'login_success': 'Login Success',
    'logout_success': 'Logout Success',
    'record_payment': 'Record Payment',
    'occupied_status': 'Occupied',
    'financial_status': 'Financial Status',
    'occupancy_physical': 'Physical Occupancy',
    'unit_indicators': 'Unit Indicators',
    'furnished_unit': 'Has Utilities Unit',
    'lease_expired_short': 'Lease Expired',
    'lease_ended_short': 'Lease Ended',
    'expired_label': 'Expired',
    'scheduled_tenants': 'Scheduled Renters',
    'multiple_leases': 'Multiple Leases',

    'renew_lease': 'Renew Lease',
    'extend_lease': 'Extend Lease',
    'current_end_date': 'Current End Date',
    'new_end_date': 'New End Date',
    'extend': 'Extend',
    'transfer': 'Transfer',
    'transfer_apartment': 'Transfer Showroom Unit',
    'current_apartment': 'Current Showroom Unit',
    'select_new_apartment': 'Select New Showroom Unit',
    'new_monthly_rent': 'New Monthly Rent',
    'transferring': 'Transferring...',
    'failed_to_transfer_tenant': 'Failed to transfer renter',
    'tenant_transferred_success': 'Renter transferred successfully',
    'expired': 'Expired',
    'select_option': 'Select Option',

    // Sales Module
    'sales': 'Sales',
    'sale_list': 'Sales List',
    'new_sale': 'New Sale',
    'record_new_sale': 'Record New Sale',
    'record_new_sale_subtitle': 'Create a buyer, assign an showroom, and set up the payment plan',
    'sales_subtitle': 'Manage property sales — buyers, showrooms & payment plans',
    'total_sales': 'Total Sales',
    'total_revenue': 'Total Revenue',
    'outstanding_balance': 'Outstanding Balance',
    'buyer': 'Buyer',
    'buyer_information': 'Buyer Information',
    'buyer_name': 'Full Name',
    'buyer_name_placeholder': 'e.g. Ahmed Al-Rashid',
    'buyer_phone': 'Phone',
    'buyer_language': 'Preferred Language',
    'select_apartment': 'Select Showroom',
    'select_apartment_required': 'Select Showroom *',
    'available_apartments_count': '{{count}} available',
    'no_apartments_available_sale': 'No showrooms available — all showrooms already have owners.',
    'payment_plan': 'Payment Plan',
    'full_payment': 'Full Payment',
    'installments_plan': 'Installments',
    'total_sale_price': 'Total Sale Price (USD)',
    'total_sale_price_placeholder': 'e.g. 75000',
    'payment_date_label': 'Payment Date',
    'first_payment_date': 'First Payment Date',
    'num_installments': 'Number of Installments',
    'per_installment_hint': '≈ ${{amount}} / installment • monthly schedule',
    'record_sale': 'Record Sale',
    'sale_recorded_success': 'Sale recorded successfully!',
    'sale_deleted': 'Sale deleted',
    'payment_recorded': 'Payment recorded',
    'no_sales_found': 'No sales found',
    'record_first_sale': 'Record the first sale',
    'sale_not_found': 'Sale not found',
    'delete_sale_confirm': 'Delete this sale? This will remove the contract and unlink the showroom.',
    'delete_sale_all_confirm': 'Delete this entire sale? This cannot be undone.',
    'sale_detail': 'Sale Detail',
    'sale_date': 'Sale Date',
    'financials': 'Financials',
    'collected': 'Collected',
    'balance': 'Balance',
    'payment_progress': 'Payment Progress',
    'installments': 'Installments',
    'due_date': 'Due Date',
    'mark_paid': 'Mark Paid',
    'confirm_payment': 'Confirm',
    'payment_date_label2': 'Payment date:',
    'overdue': 'Overdue',
    'all_statuses': 'All Statuses',
    'search_sales_placeholder': 'Search buyer, phone, showroom…',
    'sale_progress': 'Progress',
    'sale_balance': 'Balance',
    'sale_paid': 'Paid',
    'sale_unpaid': 'Unpaid',
    'sale_partial': 'Partial',
    'notes_optional': 'Notes (optional)',
    'notes_placeholder': 'Any additional info…',
    'failed_to_load_sales': 'Failed to load sales',
    'failed_to_delete_sale': 'Failed to delete sale',
    'failed_to_record_payment': 'Failed to record payment',
    'failed_to_load_sale': 'Failed to load sale',
    'failed_to_create_sale': 'Failed to create sale',
    'buyer_name_required': 'Buyer name is required',
    'valid_phone_required': 'Valid phone number is required',
    'apartment_required_sale': 'Please select an showroom',
    'valid_price_required': 'Enter a valid total price',
    'first_payment_date_required': 'First payment date is required',
    'valid_installment_amounts_required': 'Enter a valid amount for every installment',
    'installment_amounts_must_match_total': 'Installment amounts must add up to the total sale price',
    'edit_installment_amounts': 'Edit amounts manually',
    'total_allocated': 'Total allocated',
    'remaining': 'Remaining',
    'matches_total': 'Matches total price',
    'mark_as_paid_now': 'Mark as Paid Now',
    'mark_as_paid_now_hint': 'The installment(s) will be immediately marked as paid on today\'s date',
    'per_installment_paid_hint': 'First installment will be marked paid; remaining set as pending',

    // Revenue Report labels
    'rent_revenue': 'Rent Revenue',
    'service_revenue': 'Service Revenue',
    'insurance_revenue': 'Insurance Revenue',
    'sale_revenue': 'Sale Revenue',

    // Sale Commission
    'sale_has_commission': 'Real estate company takes a commission on this sale',
    'commission': 'Commission',
    'commission_percent': '% of price',
    'commission_fixed_amount': 'Fixed amount',
    'commission_rate': 'Commission rate',
    'commission_amount': 'Commission amount',
    'commission_notes': 'Commission note (optional)',
    'commission_notes_placeholder': 'e.g. agency name / reason',
    'commission_deducted_label': 'Commission deducted from this sale',
    'net_to_company': 'Net to company',
    'valid_commission_rate_required': 'Commission rate must be between 0 and 100',
    'valid_commission_amount_required': 'Commission amount must be a valid non-negative number',
    'commission_exceeds_price': 'Commission amount cannot exceed the total sale price',
    'total_commission_paid': 'Commission Paid',
    'sale_commission_expense': 'Sale Commission Paid',
    'sale_commission_expense_hint': 'Deducted for real estate agency commission on unit sales closed in this period — not netted out of Sale Revenue above.',
    'net_revenue_after_commission': 'Net Revenue (after commission)',
    'net_revenue_after_commission_hint': 'Total Revenue minus sale commission paid out. Does not include other expenses (maintenance, payroll, etc.) — not tracked in this system yet.',
    'update_complex_desc': 'Update the structural details of this complex.',
    'define_complex_desc': 'Define the location and capacity of your new logistics complex.',
    'used_for_mapping_desc': 'Used for mapping and generating official reports.',
    'how_many_blocks_desc': 'How many distinct blocks or rows does this park have?',
    'm2_free': 'm² free',
    'utilization': 'utilization',
    'overdue_payments': 'overdue payments',
    'all_payments_current': 'All payments current',
    'm2_total_area': 'm² total area',
    'type_small': 'Small',
    'type_medium': 'Medium',
    'type_large': 'Large',
    'type_extra_large': 'Extra Large',
    'type_cold_storage': 'Cold Storage',
    'type_drive-in': 'Drive-In',
    'zone': 'Zone',
    'units': 'Units',
    'front': 'Front',
    'back': 'Back',
    'side': 'Side',
    'back_row': 'Back Row',
    'front_row': 'Front Row',
    'wall': 'wall',
    'n_a': 'N/A',
    'page': 'Page',
    'showing_items': 'Showing {{start}}-{{end}} of {{total}}',
    'first_page': 'First Page',
    'previous_page': 'Previous Page',
    'next_page': 'Next Page',
    'last_page': 'Last Page',
    'showing_filtered_results': 'Showing {{showing}} of {{total}} total',
    'transaction_amount': 'Transaction Amount',
    'type': 'Type',
    'log_date': 'Log Date',
    'covered_period': 'Covered Period',
    'ref_notes': 'Ref/Notes',
    'no_transactions_found': 'No Transactions Found',
    'no_transactions_desc': 'The financial ledger for this entity is currently empty.',
    'log_transaction': 'Log Transaction',
    'initialize_ledger': 'Initialize Ledger',
    'processing_ledger': 'Processing Ledger...',
    'rent': 'Rent',
    'unknown_status': 'Unknown Status',
    'cancel': 'Cancel',
    'renew_logistics_contract': 'Renew Logistics Contract',
    'allocated_unit': 'Allocated Unit',
    'select_target_unit': 'Select Target Unit...',
    'current_unit': 'Current Unit',
    'new_base_rate': 'New Base Rate',
    'billing_cycle_start': 'Billing Cycle Start',
    'finalize_renewal': 'Finalize Renewal',
    'relocate_client_unit': 'Relocate Client Unit',
    'current_allocation': 'Current Allocation',
    'select_target_slot': 'Select Target Slot...',
    'confirm_relocation': 'Confirm Relocation',
    'processing': 'Processing...',

    // ── Service Management ──────────────────────────────────────────
    'service_payments_management': 'Service Payments Management',
    'service_payments_for_building_year': 'Service payments for {{building}} — {{year}}',
    'back_to_dashboard': 'Back to Dashboard',
    'refresh': 'Refresh',
    'data_refreshed_successfully': 'Data refreshed successfully',
    'failed_to_refresh_data': 'Failed to refresh data',
    'loading_service_data': 'Loading service data...',
    'select_building': 'Select Building',
    'no_building_selected': 'No building selected',
    'please_select_building': 'Please select a building to view service payments.',
    'no_floors_available': 'No Floors Available',
    'no_floors_message': 'There are no floors with showroom units in this building, or no service payments have been generated yet.',
    'failed_to_load_buildings': 'Failed to load buildings',
    'failed_to_load_floors': 'Failed to load floors',
    'failed_to_load_floor_data': 'Failed to load floor data',
    'failed_to_load_building_floors': 'Failed to load building floors',
    'no_apartments_on_floor': 'No showroom units found on this floor.',
    'no_matching_apartments': 'No showroom units match your search.',
    'no_search_results': 'No results match your search.',
    'filter_by_status': 'Filter by Status',
    'search_apartments_tenants': 'Search units, owners, renters...',
    'view_statistics': 'View Statistics',
    'summary': 'Summary',
    'zone_showroom_count': 'Zone {{zone}} — {{count}} units',
    'generate_payment': 'Generate Payment',
    'generate_payment_for': 'Generate Payment for Showroom {{number}}',
    'payment_amount': 'Payment Amount',
    'enter_amount': 'Enter amount',
    'invalid_amount': 'Please enter a valid amount greater than 0',
    'mark_as_paid_immediately': 'Mark as paid immediately',
    'payment_notes': 'Payment Notes',
    'required_fields': 'Required fields',
    'payment_generated_successfully': 'Payment generated successfully',
    'failed_to_generate_payment': 'Failed to generate payment',
    'failed_to_update_payment': 'Failed to update payment',
    'payment_marked_as_paid': 'Payment marked as paid',
    'payment_marked_as_unpaid': 'Payment marked as unpaid',
    'marked_as_paid_via_service_management': 'Marked as paid via service management',
    'marked_as_unpaid_via_service_management': 'Marked as unpaid via service management',
    'payment_details': 'Payment Details',
    'payment_due': 'Payment Due',
    'paid_on': 'Paid on {{date}}',
    'rate': 'Rate',
    'unpaid': 'Unpaid',

    // ── Building View ───────────────────────────────────────────────
    'edit_complex': 'Edit Complex',
    'attention_required': 'Attention Required',
    'overdue_payment': 'Overdue Payment',
    'available': 'Available',
    'vacant_available': 'Vacant / Available',
    'corner': 'Corner',

    // ── Owner Form / Sale Form ──────────────────────────────────────
    'failed_to_load_data': 'Failed to load data',
    'failed_to_save_owner': 'Failed to save owner',
    'lives_on_property': 'Lives on Property',
    'monthly_service_fee_applies': 'Monthly service fee applies',
    'works_at_showroom': 'Buyer works at this showroom',
    'change': 'Change',

    // ── 2FA / OTP ───────────────────────────────────────────────────
    'otp_security_verification': 'Security Verification',
    'otp_enter_code_whatsapp': 'Please enter the verification code sent to your WhatsApp.',
    'otp_verification_code': 'Verification Code',
    'otp_check_whatsapp': 'Check your WhatsApp for the code',
    'otp_invalid_code': 'Please enter a valid verification code',
    'otp_resent': 'Verification code resent to your WhatsApp',
    'otp_verify_code': 'Verify Code',
    'otp_verifying': 'Verifying...',
    'otp_resend_code': 'Resend Code',
    'otp_back_to_login': 'Back to Login',
  }
};